;(function() {
/*! AdService 2 Connector
 *
 *  @version 2.2.9
 *
 *  @author Marcus Klumpp
 *  @see Wiki:TAM/AdService2
 */

var securedSymbol = typeof Symbol === 'function' ? Symbol('secured') : '_'+parseInt((''+Math.random()).substr(2)).toString(16);

var precalls = window.AdService instanceof Array ? window.AdService.slice() : [];
window.AdService = new function() {
    var self = this,
        win  = window,
        doc  = win.document,
        loc  = win.location,
    _;
    self._isConnector = true;
        var Const = {
            REQUEST_METHOD: {
                SCRIPT_SRC: 'SCRIPT_SRC',
                AJAX: 'AJAX',
                NONFRIENDLY_IFRAME: 'NONFRIENDLY_IFRAME',
                FRIENDLY_IFRAME: 'FRIENDLY_IFRAME',
            _:0},
            REQUEST_TYPE: {
                SYNC: 'SYNC',
                ASYNC: 'ASYNC',
            _:0},
            AJAX_DATA_TYPE: {
                JSON: 'JSON',
                XML: 'MARKUP',
                HTML: 'STRING',
                TEXT: 'STRING',
            _:0},
            OVERRIDE_PARAM_PREFIX: '_ad.',
            LOGLEVEL_PARAM_PREFIX: '_ad_loglevel.',
            MESSAGE_TYPE: {
                CALL: 'CALL',
                ANSWER: 'ANSWER',
                DEMAND_REDO: 'DEMAND_REDO',
            _:0},
        _:0};
        self.Const = Const;

    if (!Array.prototype.indexOf) {
        Array.prototype.indexOf = function(elt ) {
            var len = this.length >>> 0,
                from = Number(arguments[1]) || 0;
            from = (from < 0)
                 ? Math.ceil(from)
                 : Math.floor(from);
            if (from < 0) {
                from += len;
            }
            for (; from < len; from++) {
                if (from in this && this[from] === elt) {
                    return from;
                }
            }
            return -1;
        };
    }
    Function.prototype.bind = (function() {}).bind || function(b) {
        if (typeof this !== 'function') {
            throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
        }
        function c() {}
        var a = [].slice,
            f = a.call(arguments, 1),
            e = this,
            d = function() {
                return e.apply(this instanceof c ? this : b || win, f.concat(a.call(arguments)));
            };
        c.prototype = this.prototype;
        d.prototype = new c();
        return d;
    };
    if (typeof Object.create !== 'function') {
        Object.create = function(o, props) {
            function F() {}
            F.prototype = o;
            if (typeof(props) === 'object') {
                for (prop in props) {
                    if (props.hasOwnProperty((prop))) {
                        F[prop] = props[prop];
                    }
                }
            }
            return new F();
        };
    }
    (function(root) {
        if (!root.CSS) { root.CSS = {}; }
        var CSS = root.CSS;
        if (CSS.escape) { return; }

            var InvalidCharacterError = function(message) {
            this.message = message;
        };
        InvalidCharacterError.prototype = new Error;
        InvalidCharacterError.prototype.name = 'InvalidCharacterError';

        CSS.escape = function(value) {
            var string = String(value);
            var length = string.length;
            var index = -1;
            var codeUnit;
            var result = '';
            var firstCodeUnit = string.charCodeAt(0);
            while (++index < length) {
                codeUnit = string.charCodeAt(index);

                if (codeUnit == 0x0000) {
                    throw new InvalidCharacterError(
                        'Invalid character: the input contains U+0000.'
                    );
                }

                    if (
                    (codeUnit >= 0x0001 && codeUnit <= 0x001F) || codeUnit == 0x007F ||
                    (index == 0 && codeUnit >= 0x0030 && codeUnit <= 0x0039) ||
                    (
                        index == 1 &&
                        codeUnit >= 0x0030 && codeUnit <= 0x0039 &&
                        firstCodeUnit == 0x002D
                    )
                ) {
                    result += '\\' + codeUnit.toString(16) + ' ';
                    continue;
                }

                    if (
                    index == 0 &&
                    length == 1 &&
                    codeUnit == 0x002D
                ) {
                    result += '\\' + string.charAt(index);
                    continue;
                }

                if (
                    codeUnit >= 0x0080 ||
                    codeUnit == 0x002D ||
                    codeUnit == 0x005F ||
                    codeUnit >= 0x0030 && codeUnit <= 0x0039 ||
                    codeUnit >= 0x0041 && codeUnit <= 0x005A ||
                    codeUnit >= 0x0061 && codeUnit <= 0x007A
                ) {
                    result += string.charAt(index);
                    continue;
                }

                result += '\\' + string.charAt(index);

                }
            return result;
        };
    }).apply(self, [win]);
    (function(root) {
        if (!root.Promise) {
            var setTimeoutFunc = root.setTimeout;
            function noop() {}

            var asap = (typeof setImmediate === 'function' && setImmediate) || function(fn) { setTimeoutFunc(fn, 1); };

            function bind(fn, thisArg) {
                return function() {
                    fn.apply(thisArg, arguments);
                }
            }

                var isArray = Array.isArray || function(value) { return Object.prototype.toString.call(value) === "[object Array]" };

                function Promise(fn) {
                if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
                if (typeof fn !== 'function') throw new TypeError('not a function');
                this._state = 0;
                this._value = undefined;
                this._deferreds = [];
                doResolve(fn, this);
            }

                function handle(self, deferred) {
                while (self._state === 3) {
                    self = self._value;
                }
                if (self._state === 0) {
                    self._deferreds.push(deferred);
                    return;
                }
                asap(function() {
                    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected
                    if (cb === null) {
                        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
                        return;
                    }
                    var ret;
                    try {
                        ret = cb(self._value);
                    } catch (e) {
                        reject(deferred.promise, e);
                        return;
                    }
                    resolve(deferred.promise, ret);
                });
            }

                function resolve(self, newValue) {
                try {
                    if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
                    if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
                        var then = newValue.then;
                        if (newValue instanceof Promise) {
                            self._state = 3;
                            self._value = newValue;
                            finale(self);
                            return;
                        } else if (typeof then === 'function') {
                            doResolve(bind(then, newValue), self);
                            return;
                        }
                    }
                    self._state = 1;
                    self._value = newValue;
                    finale(self);
                } catch (e) {
                    reject(self, e);
                }
            }

                function reject(self, newValue) {
                self._state = 2;
                self._value = newValue;
                finale(self);
            }

                function finale(self) {
                for (var i=0, len=self._deferreds.length; i<len; i++) {
                    handle(self, self._deferreds[i]);
                }
                self._deferreds = null;
            }

                function Handler(onFulfilled, onRejected, promise){
                this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
                this.onRejected = typeof onRejected === 'function' ? onRejected : null;
                this.promise = promise;
            }


            function doResolve(fn, self) {
                var done = false;
                try {
                    fn(function(value) {
                        if (done) { return; }
                        done = true;
                        resolve(self, value);
                    }, function(reason) {
                        if (done) { return; }
                        done = true;
                        reject(self, reason);
                    })
                } catch (ex) {
                    if (done) { return; }
                    done = true;
                    reject(self, ex);
                }
            }

                Promise.prototype['catch'] = function(onRejected) {
                return this.then(null, onRejected);
            };

                Promise.prototype.then = function(onFulfilled, onRejected) {
                var prom = new Promise(noop);
                handle(this, new Handler(onFulfilled, onRejected, prom));
                return prom;
            };

                Promise.all = function() {
                var args = Array.prototype.slice.call(arguments.length === 1 && isArray(arguments[0]) ? arguments[0] : arguments);
                return new Promise(function(resolve, reject) {
                    if (args.length === 0) return resolve([]);
                    var remaining = args.length;
                    function res(i, val) {
                        try {
                            if (val && (typeof val === 'object' || typeof val === 'function')) {
                                var then = val.then;
                                if (typeof then === 'function') {
                                    then.call(val, function(val) { res(i, val) }, reject);
                                    return;
                                }
                            }
                            args[i] = val;
                            if (--remaining === 0) {
                                resolve(args);
                            }
                        } catch (ex) {
                            reject(ex);
                        }
                    }
                    for (var i=0, len=args.length; i<len; i++) {
                        res(i, args[i]);
                    }
                });
            };

                Promise.resolve = function(value) {
                if (value && typeof value === 'object' && value.constructor === Promise) {
                    return value;
                }
                return new Promise(function(resolve) {
                    resolve(value);
                });
            };

                Promise.reject = function(value) {
                return new Promise(function(resolve, reject) {
                    reject(value);
                });
            };

                Promise.race = function(values) {
                return new Promise(function(resolve, reject) {
                    for (var i=0, len=values.length; i<len; i++) {
                        values[i].then(resolve, reject);
                    }
                });
            };

                /**
             * Set the immediate function to execute callbacks
             * @param fn {function} Function to execute
             * @private
             */
            Promise._setImmediateFn = function _setImmediateFn(fn) {
                asap = fn;
            };
            root.Promise = Promise;
        }
    }).apply(self, [win]);
    (function() {
        if (typeof window.CustomEvent === 'function') { return; }
        function CustomEvent (event, params) {
            params = params || {bubbles: false, cancelable: false, detail: undefined};
            var evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        }
        CustomEvent.prototype = window.Event.prototype;
        window.CustomEvent = CustomEvent;
    }).apply(self);

        var Version = function(obj) {
            this.parse.apply(this, arguments);
        };
        Version.LEVEL_UNKNOWN = null;
        Version.LEVEL_DEV = 'dev';
        Version.LEVEL_ALPHA = 'alpha';
        Version.LEVEL_BETA = 'beta';
        Version.LEVEL_RC = 'rc';
        Version.LEVEL_FINAL = '';
        Version.levels = [Version.LEVEL_DEV, Version.LEVEL_ALPHA, Version.LEVEL_BETA, Version.LEVEL_RC, Version.LEVEL_FINAL];
        Version.prototype.parse = function(obj) {
            if (typeof obj !== 'object') {
                if (typeof obj === 'string') {
                    var p1 = obj.split('-');
                    var p2 = p1[0].split('.');
                    obj = {
                        major: p2[0],
                        minor: p2[1],
                        revision: p2[2],
                        level: p1[1]
                    };
                } else if (typeof obj === 'number') {
                    obj = {
                        major: parseInt(obj, 10),
                        minor: parseInt((''+obj+'.0').substr((''+obj+'.').indexOf('.')+1), 10)
                    };
                } else {
                    obj = {
                        major: arguments[0],
                        minor: arguments[1],
                        revision: arguments[2],
                        level: arguments[3]
                    };
                }
            }
            this._data = obj;
            this.major = parseInt(obj.major, 10) || 0;
            this.minor = parseInt(obj.minor, 10) || 0;
            this.revision = parseInt(obj.revision, 10) || 0;
            this.level = (''+(obj.level || '')).toLowerCase();
            if (obj.hasOwnProperty('build')) { this.build = obj.build; }
            this.majorminor = parseFloat(this.major + '.' + this.minor, 10);
            if (Version.levels.indexOf(this.level) < 0) {
                this.level = Version.LEVEL_UNKNOWN;
            }
        };
        Version._compareOrder = ['major', 'minor', 'revision', 'level'];
        Version.prototype._compare = function(that, lt, gt, eq) {
            that = new Version(that);
            for (var i=0, l=Version._compareOrder.length; i<l; i++) {
                if (Version._compareOrder[i] === 'level') {
                    var ixThis = Version.levels.indexOf(this.level) + 1;
                    var ixThat = Version.levels.indexOf(that.level) + 1;
                    if (!(ixThis*ixThat)) { return eq; }
                    if (ixThis > ixThat)  { return gt; }
                    if (ixThis < ixThat)  { return lt; }
                    return eq;
                }
                if (this[Version._compareOrder[i]] > that[Version._compareOrder[i]]) return gt;
                if (this[Version._compareOrder[i]] < that[Version._compareOrder[i]]) return lt;
            }
            return eq;
        };
        Version.prototype.eq = function(that) {
            return this._compare(that, false, false, true);
        };
        Version.prototype.ne = function(that) {
            return this._compare(that, true, true, false);
        };
        Version.prototype.gt = function(that) {
            return this._compare(that, false, true, false);
        };
        Version.prototype.gte = function(that) {
            return this._compare(that, false, true, true);
        };
        Version.prototype.lt = function(that) {
            return this._compare(that, true, false, false);
        };
        Version.prototype.lte = function(that) {
            return this._compare(that, true, false, true);
        };
        Version.prototype.toString = function() {
            var version = [this.major, this.minor, this.revision].join('.');
            if (this.level) {
                version += '-' + this.level;
            }
            return version;
        };
    (function() {
        var version = '2.2.9'.split('.');
        self.version = new Version({major: version[0], minor: version[1], revision: version[2], level: Version.LEVEL_FINAL});
    }).apply(self);

    (function() {
        var exports = {};

                self._registerExport = function(name, obj) {
            exports[name] = obj;
        };
        self.gimme = function(name) {
            if (name) {
                return exports[name];
            }
            return keys(exports);
        };
        self.gimmeAll = function(nameMap) {
            nameMap = nameMap || {};
            var items = self.gimme();
            each(items, function(i, item) {
                win[nameMap[item] || item] = self.gimme(item);
            });
        };
    }).apply(self);
    (function() {
        var _console,
            _coreLevels = {'false':true},
            _levels = {
                raw: false,
                debug: true,
                info: true,
                warn: true,
                error: true,
            _:0};
        for (var i in _levels) {
            if (!_levels.hasOwnProperty(i) || i==='_') { continue; }
            _coreLevels[i] = true;
        }
        function prependToArguments(args) {
            var result = Array.prototype.slice.call(args);
            result.unshift.apply(result, Array.prototype.slice.call(arguments, 1));
            return result;
        }
        function appendToArguments(args) {
            var result = Array.prototype.slice.call(args);
            result.push.apply(result, Array.prototype.slice.call(arguments, 1));
            return result;
        }
        function pad(value, len) {
            value = ''+value;
            len = len || 2;
            while (value.length < len) {
                value = '0' + value;
            }
            return value;
        }
        function now() {
            var now = new Date();
            return      pad(now.getHours())
                + ':' + pad(now.getMinutes())
                + ':' + pad(now.getSeconds())
                + '.' + pad(now.getMilliseconds(), 3);
        }

                self.log = function() {
            self.log.debug.apply(self, arguments);
        };
        self.log._output = function() {
            if (!arguments[0].doit) { return; }
            var log = prependToArguments(Array.prototype.slice.call(arguments, 1), '['+(arguments[0].force?'!':'')+'AdService:'+arguments[0].title+']' + (arguments[0].omitTime ? '' : ' '+now())),
                method = _console[arguments[0].method || arguments[0].title] || _console.log;
            if ('apply' in method) {
                method.apply(_console, log);
            } else {
                method(log.join(' '));
            }
        };
        self.log.consoleDebug = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:_levels.debug && self._debugMode, title:'raw', method:'debug'}));
        };
        self.log.debug = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:_levels.debug && self._debugMode, title:'debug', method:'log'}));
        };
        self.log.info = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:_levels.info && self._debugMode, title:'info'}));
        };
        self.log.warn = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:_levels.warn && self._debugMode, title:'warn'}));
        };
        self.log.error = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:_levels.error && self._debugMode, title:'error'}));
        };
        self.log.level = function(level) {
            self.log._output.apply(self, prependToArguments(Array.prototype.slice.call(arguments, 1), {doit:_levels[level] && self._debugMode, title:level}));
        };
        self.log.force = function() {
            self.log.forceDebug.apply(self, arguments);
        };
        self.log.remind = function() {
            self.log._output.apply(self, appendToArguments(prependToArguments(arguments, {doit:true, title:'TODO', method:'warn'}, '[REMINDER]'), '\n'+(''+(new Error()).stack).split('\n').slice(2).join('\n')));
        };
        self.log.deprecated = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:true, title:'deprecated', method:'warn', omitTime:true}));
        };
        self.log.nyi = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:true, title:'interface', method:'error'}, 'NOT YET IMPLEMENTED:'));
        };
        self.log.forceConsoleDebug = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:true,title: 'raw', force:true}));
        };
        self.log.forceDebug = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:true, title:'debug', force:true}));
        };
        self.log.forceInfo = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:true, title:'info', force:true}));
        };
        self.log.forceWarn = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:true, title:'warn', force:true}));
        };
        self.log.forceError = function() {
            self.log._output.apply(self, prependToArguments(arguments, {doit:true, title:'error', force:true}));
        };
        self.log.forceLevel = function(level) {
            self.log._output.apply(self, prependToArguments(Array.prototype.slice.call(arguments, 1), {doit:true, title:level, force:true}));
        };
        self.log.setLevel = function(level, isSet) {
            if (typeof level === 'object') {
                for (var i in level) {
                    if (!level.hasOwnProperty(i)) { continue; }
                    if (i === '_') { continue; }
                    _levels[i] = level[i];
                }
            } else {
                if (_coreLevels[level]) {
                    var value = false;
                    for (var i in _levels) {
                        if (!_levels.hasOwnProperty(i)) { continue; }
                        if (i === level) { value = true; }
                        if (i === '_')   { break; }
                        _levels[i] = value;
                    }
                }
                _levels[level] = isSet !== false;
            }
        };
        self.log.getLevel = function() {
            return _levels;
        };

                self.setDebugMode = function(yesno) {
            var previous = self._debugMode;
            self._debugMode = yesno === undefined ? true: yesno;
            if (self._debugMode) {
                if (previous) {
                    self.log.info('Already in Debug Mode.');
                } else {
                    self.log.info('Entering Debug Mode. Reason(s):', debugOrigin.length ? debugOrigin : prependToArguments((''+(new Error()).stack).split('\n').slice(2), 'manual call'));
                }
            } else if (previous) {
                self.log.forceInfo('Stopping Debug Mode.');
            }
            debugOrigin = [];
        };

                self.log.getConsoleObject = function() {
            return _console;
        };
        self.log.setConsoleObject = function(obj) {
            _console = obj;
        };
        self.log._consoleCompensation = [];
        self.log.setConsoleObject(console || {
            debug: function() { self.log._consoleCompensation.push({type:'debug', args:arguments}); },
            log: function() { self.log._consoleCompensation.push({type:'log', args:arguments}); },
            info: function() { self.log._consoleCompensation.push({type:'info', args:arguments}); },
            warn: function() { self.log._consoleCompensation.push({type:'warn', args:arguments}); },
            error: function() { self.log._consoleCompensation.push({type:'error', args:arguments}); }
        });

        var urlParams = location.search.substr(1).split('&');
        for (var i=0, l=urlParams.length; i<l; i++) {
            var param = urlParams[i],
                name = param.substr(0, param.indexOf('=')),
                value = param.substr(param.indexOf('=')+1),
            _;
            if (name.indexOf(Const.LOGLEVEL_PARAM_PREFIX) !== 0) { continue; }
            self.log.setLevel(name.substr(Const.LOGLEVEL_PARAM_PREFIX.length), value !== 'false');
        }

        var debugMode = false,
            debugOrigin = [];
        if (doc.documentElement.getAttribute('data-adservice-debug') !== null) {
            debugMode = (''+doc.documentElement.getAttribute('data-adservice-debug')).toLowerCase() === 'true';
            if (debugMode) { debugOrigin.push('html attribute'); }
        }
        if (window.adserviceDebug) {
            debugMode = !!window.adserviceDebug;
            if (debugMode) { debugOrigin.push('global variable'); }
        }
        if (/[?&]adservice-debug=(true|false)(&|$)/.test(loc.search)) {
            debugMode = RegExp.$1 === 'true';
            if (debugMode) { debugOrigin.push('url parameter'); }
        }
        self.setDebugMode(debugMode);
    }).apply(self);
    (function() {
        self.Helper = new function() {
            this.register = function(name, ref) {
                self._registerExport(name, ref);
                this[name] = ref;
            };
        };
    }).apply(self);

            function each(obj, func, completeWalkthrough) {
            if (obj instanceof Array || isArguments(obj) || isDomList(obj)) {
                for (var i=0, l=obj.length; i<l; i++) {
                    try { func(i, obj[i]); }
                    catch (e) { self.log.error('Error in function supplied for each(Array)', e, i, obj[i], arguments, this); }
                }
            } else {
                for (var i in obj) {
                    if (completeWalkthrough !== true && !obj.hasOwnProperty(i)) { continue; }
                    try { func(i, obj[i]); }
                    catch (e) { self.log.error('Error in function supplied for each(Object)', e, i, obj[i], arguments, this); }
                }
            }
        }

            function keys(obj) {
            var keys = [];
            each(obj, function(key, value) { keys.push(key); });
            return keys;
        }

            function filter(obj, func) {
            var result = obj instanceof Array ? [] : {};
            each(obj, function(name, value) {
                if (func(name, value)) {
                    obj instanceof Array ? result.push(value) : (result[name] = value);
                }
            });
            return result;
        }

            function objCompare(obj1, obj2) {
            self.log.remind('objCompare', arguments);
        }

            function deepCopy(obj) {
            switch (true) {
                case obj === undefined:
                case obj === null:
                case !(obj instanceof Object):
                    return obj;
                case obj.constructor === Number:
                case obj.constructor === String:
                case obj.constructor === Boolean:
                case obj.constructor === Date:
                case obj.constructor === RegExp:
                case obj.constructor === Function:
                    return new obj.constructor(obj);
                case obj instanceof Array:
                    var temp = [];
                    for (var i=0, l=obj.length; i<l; i++) {
                        temp[i] = deepCopy(obj[i]);
                    }
                    return temp;
                default:
                    return extend({}, obj);
            }
        }

            function makeArray(obj, forcePlainObjectToArray) {
            switch (true) {
                case (obj === undefined):
                    return [];
                case (obj instanceof Array):
                    return obj;
                case (isArguments(obj)):
                case (obj instanceof win.NodeList):
                    var temp = [];
                    each(obj, function(i, item) { temp[i] = item; });
                    return temp;
                case (obj instanceof Object && forcePlainObjectToArray):
                    var temp = [];
                    each(obj, function(i, item) { temp[i] = item; });
                    return temp.length ? temp : [obj];
                default:
                    return [obj];
            }
            return obj;
        }

            function arrayMerge() {
            var result = [];
            each(arguments, function(index, array) {
                if (!(array instanceof Array) && !isArguments(array)) {
                    return result.push(array);
                }
                each(array, function(index, item) {
                    result.push(item);
                });
            });
            return result;
        }

            function isArguments(obj) {
            return obj && obj.callee && obj.callee.arguments === obj;
        }

            function isDomElement(obj) {
            return obj instanceof win.HTMLElement;
        }

            function isDomList(obj) {
            return obj instanceof win.HTMLCollection;
        }

            function extend() {
            function _extend(object1, object2) {
                each(object2, function(key, value) {
                    if (typeof value === 'object' && !(value instanceof Array)) {
                        if (typeof object1[key]  === 'undefined') {
                            object1[key] = value;
                        } else {
                            _extend(object1[key], value);
                        }
                    } else {
                        object1[key] = value;
                    }
                }, (object2 instanceof (win.DOMRect || win.ClientRect)));
                return object1;
            }

                var result = arguments[0];
            for (var i=1, l=arguments.length; i<l; i++) {
                result = _extend(result, arguments[i] || {});
            }
            return result;
        }

            function defaults(obj, defaults) {
            return extend(defaults, obj);
        }

            function fillIn(text, placeholder, regexp) {
            return text.replace(regexp || /\{([^}]+)\}/g, function(match, key) {
                return placeholder.hasOwnProperty(key) ? placeholder[key] : match;
            });
        }

            function getLengthValue(value) {
            if (typeof value === 'number') { return value + 'px'; }
            if ((''+value).indexOf('%') > 0) { return parseInt(value) + '%'; }
            return parseInt(value) + 'px';
        }

        function parseUrl(url) {
            var result = {};
            result.originalUrl = url;
            var parts = url.match(/^(https?:)?(?:\/\/([^:/]+?)(?::(\d+))?)?(\/[^?#]*)?(\?[^#]*)?(#.*)?$/);
            result.protocol = parts[1];
            result.hostname = parts[2];
            result.port = parts[3];
            result.pathname = parts[4];
            result.search = parts[5];
            result.hash = parts[6];
            result.host = result.hostname + (result.port ? ':'+result.port : '');
            result.origin = result.protocol + '//' + result.host;

                return result;
        }

            self.Helper.register('each', each);
        self.Helper.register('keys', keys);
        self.Helper.register('filter', filter);
        self.Helper.register('deepCopy', deepCopy);
        self.Helper.register('makeArray', makeArray);
        self.Helper.register('arrayMerge', arrayMerge);
        self.Helper.register('isArguments', isArguments);
        self.Helper.register('isDomElement', isDomElement);
        self.Helper.register('isDomList', isDomList);
        self.Helper.register('defaults', defaults);
        self.Helper.register('extend', extend);
        self.Helper.register('fillIn', fillIn);
        self.Helper.register('getLengthValue', getLengthValue);
        self.Helper.register('parseUrl', parseUrl);
    (function() {
        self.FunctionHook = function() {
            this._functionList = [];
        }
        self.FunctionHook.prototype.check = function(func) {
            return false;
        };
        self.FunctionHook.prototype.add = function(func) {
            this._functionList.push(func);
            if (this.check()) {
                func.apply(this, Array.prototype.slice.call(arguments, 1));
            }
        };
        self.FunctionHook.prototype.run = function() {
            var args = arguments;
            each(this._functionList, function(i, item) {
                item.apply(this, args);
            });
        };
        self.FunctionHook.prototype.clear = function() {
            this.onclear();
            this._functionList = [];
        };
        self.FunctionHook.prototype.onclear = function() {
        };
    }).apply(self);
    (function() {
        var config = {
                'data-attribute-namespace': 'adservice',
                'friendlyiframe-adscript-id': 'external-script',
                'friendlyiframe-checkscript-id': 'internal-script',
                'friendlyiframe-readycheck-timeout': 50,
                'nonfriendlyiframe-document': 'https://dl.web.de/uim/nonfriendlyiframe.html',
                'visibility-minimum-fraction': 0.5,
                'request-ad-only-if-visible': true,
                'request-async': false,
                'adservice-iframe-script-url': 'connector.js',
                'auto-exchange-uim-cookie': false,
                'auto-set-iframe-size': true,
                'slot-enabled-default': true,
            _:0};
        delete config._;
        /**
         * retrieves the AdService configuration.
         * @function getConfig
         * @param {string} [name] - configuration key name
         * @example AdService.getConfig('adservice-iframe-script-url');
         * @example AdService.getConfig();
         */
        self.getConfig = function(name, defaultValue) {
            if (!name) { return config; }
            if (config.hasOwnProperty(name)) { return config[name]; }
            return defaultValue;
        };

                /**
         * sets the AdService configuration.
         * @function setConfig
         * @param {string} name - configuration key name
         * @param {*} value - value of the configuration key
         * @example AdService.setConfig('visibility-minimum-fraction',0.6);
         */
        self.setConfig = function(name, value) {
            var obj = arguments.length>1 ? {} : name;
            if (arguments.length>1) {
                obj[name] = value;
            }
            each(obj, function(name, value) { config[name] = value; });
            return self;
        };
    }).apply(self);
        var dom;
        if (doc.querySelectorAll) {
            dom = function(selector, context) {
                if (!context) { context = doc; }
                return context.querySelectorAll(selector);
            };
        } else {
            dom = function(selector, context) {
                var id = null,
                    tempId = false;
                AdService.__domList = new Array();
                if (context) {
                    if (context.id) {
                        id = context.id;
                    } else {
                        tempId = true;
                        id = context.id = 'temp-dom-id-'+(''+new Date().getTime()).substr(2);
                    }
                }
                var style = doc.createElement('style');
                doc.getElementsByTagName('head')[0].appendChild(style);
                style.styleSheet.cssText = (id ? '#'+id+' ' : '') + selector + '{x-dom: expression(AdService.__domList.push(this));}';
                win.scrollBy(0, 0);
                style.parentNode.removeChild(style);
                if (tempId) { context.removeAttribute('id'); }
                return [].concat(AdService.__domList);
            }
        }
        self.getDataAttrName = function(suffix) {
            return 'data-' + CSS.escape(self.getConfig('data-attribute-namespace')) + '-' + suffix;
        };
        /**
         * creates a DOM-element
         * @function createElement
         * @param {string} name - dom element name
         * @param {object} attrs - attributes of the dom element {key1: value1, key2:value2, key3:value3...}
         * @param {object} props - properties of the dom element {key1: value1, key2:value2, key3:value3...}
         * @example AdService.createElement('div',
            {
                id:'foo',
                class:'hidden',
                style:'width:100%;height:120px;background-color:yellow;'
            },
            {
                foo: function(){ alert("bar"); }
            }
        );
         */
        self.createElement = function(name, attrs, props) {
            var el = document.createElement(name);
            each(attrs, function(n, v) { el.setAttribute(n, v); });
            each(props, function(n, v) { el[n] = v; });
            return el;
        };
        /**
         * creates an IFrame within a DOM-element
         * @function buildFriendlyIframe
         * @param {domNode} domNode - dom node where to create the iframe
         * @param {object} data - data containing information about the content of the iframe - slot, markup...
         */
        self.buildFriendlyIframe = function(domNode, data, type) {
            var slot = data.slot,
                width = slot.fixedSize.type === 'fixed' ? slot.fixedSize.width : '100%',
                height = slot.fixedSize.type === 'fixed' ? slot.fixedSize.height : domNode.offsetHeight||'100%',
                iframeSrc = document.all ? "javascript:(function(){document.open('text/html', 'replace');document.domain='" + document.domain + "';})();" : 'about:blank',
                iframeAttrs = {frameborder: 0, border: 0, scrolling: 'no', marginwidth: 0, marginheight: 0, width: width, height: height},
            _;
            if (Object.keys(slot.sandboxAttributes).length) { iframeAttrs.sandbox = slot.getSandboxAttributeValue(); }
            if (slot.fixedSize.type === 'pagecontrol') {
                delete iframeAttrs.width;
                delete iframeAttrs.height;
            }
            var iframe = self.createElement('iframe', iframeAttrs, {src: iframeSrc});
            domNode.appendChild(iframe);
            var iframeWindow = iframe.contentWindow,
                iframeDocument = iframeWindow.document;
            iframeDocument.open();


            self.trigger('ad.request', slot, data);
            iframeDocument.write(''
                + '<!DOCTYPE html>\n'
                + '<html>\n'
                + '<head>\n'
                + '<meta charset="UTF-8"/>\n'
                + '<script>\n'
                + '    var _adServer = "' + data.slot.getAdServer().id + '";\n'
                + '    var _adSlot = "' + data.slot.id + '";\n'
                + '    window.AdService = [];\n'
                + '    function checkAdReady() { document.close(); }\n'
                + '    function checkRunner() {\n'
                + '        if (checkRunner.finished) { return; }\n'
                + '        if (window.AdService instanceof Array && --checkRunner.triesLeft) {\n'
                + '            checkRunner.timeout += 5;\n'
                + '            return window.setTimeout(checkRunner, checkRunner.timeout);\n'
                + '        }\n'
                + '        checkRunner.finished = true;\n'
                + '        checkAdReady();\n'
                + '    }\n'
                + '    checkRunner.timeout = 20;\n'
                + '    checkRunner.triesLeft = 25;\n'
                + '</script>\n'
                + '<script src="' + Code.html(self.getConfig('adservice-iframe-script-url')) + '"><\/script>\n'
                + '<style>\n'
                + 'html { overflow: hidden; }\n'
                + 'html, body { min-width: 100%; min-height: 100%; }\n'
                + 'img, iframe { display: block; }\n'
                + 'a img { border: none; }\n'
                + 'html.testsize { display: table !important; }\n'
                + 'html.testsize * { float: left !important; }\n'
                + 'html.testsize .adp-admarker-icon + .adp-admarker-text { display: none; }\n'
                + '<\/style>\n'
                + '<style id="pageStyles">' + (type ? self.useIframeCss(type) : '') + '</style>\n'
                + '<\/head>\n'
                + '<body><div>\n'
                + data.html
                + '<script id="internal-script">checkRunner();<\/script>\n'
                + '<\/body>\n'
                + '<\/html>'
            );
            self.trigger('ad.requested', slot, data);
            self.log.level('friendlyiframe', 'iframe.document.created', iframeWindow.frameElement.parentNode.getAttribute(self.getDataAttrName('slot')));

                return true;

            };

            self._registerExport('dom', dom);
    (function() {
        var eventListener = {};

                var AdServiceEvent = function(evn, slot, data) {
            this.type = evn;
            this.data = data || {};
            this.slot = slot || null;
            this.target = this.data.target || (this.slot && this.slot.getTarget && this.slot.getTarget()) || null;
            this.request = this.data.request || (this.slot && this.slot.getRequest && this.slot.getRequest()) || null;
        };
        AdServiceEvent.prototype.get = function(name, defaultValue) {
            return this.data.hasOwnProperty(name) ? this.data[name] : (defaultValue || undefined);
        };
        AdServiceEvent.prototype.set = function(name, value) {
            this.data[name] = value;
        };

                self.on = function(evn, condition, func) {
            if (!func) {
                func = condition;
                condition = undefined;
            }
            if (evn === 'now') {
                return func.apply(self);
            }
            self._initEventName(evn);
            if (eventListener[evn].isUnique && eventListener[evn].triggered && self._eventConditionFulfilled(condition)) {
                return self._runEventListener(func);
            }
            var eventFunc = function() {
                var event = arguments[0] instanceof AdServiceEvent ? arguments[0] : null;
                if (!this.condition || self._eventConditionFulfilled(this.condition, event)) {
                    this.func.apply(this, arguments);
                }
            };
            eventFunc.condition = condition;
            eventFunc.func = func;
            eventFunc = eventFunc.bind(eventFunc);
            eventListener[evn].add(eventFunc);
            self.trigger('eventhandler.added', {on: evn, condition: condition, func: func, eventFunc: eventFunc});
            return self;
        };
        self.trigger = function(evn, slot, data) {
            self.log.level('event.trigger', evn, slot, data && extend({}, data), arguments);
            if (!eventListener[evn]) { return; }
            if (eventListener[evn].isUnique && eventListener[evn].triggered) { return; }
            if (slot && !(slot instanceof self.AdSlot)) {
                data = slot;
                slot = null;
            }
            eventListener[evn].triggered = true;
            eventListener[evn].run(new AdServiceEvent(evn, slot, data));
            return self;
        };
        self._from_iframe_triggerUp = function(evn, slot, data) {
            self.trigger(evn, self.AdSlot(slot), data);
        };
        self._triggerFlat = function(evn) {
            self.log.level('event._triggerFlat', evn, arguments);
            if (!eventListener[evn]) { return; }
            if (eventListener[evn].isUnique && eventListener[evn].triggered) { return; }
            eventListener[evn].triggered = true;
            eventListener[evn].run.apply(eventListener[evn], [].splice.call(arguments, 1));
            return self;
        };
        self.triggerOnce = function(evn, slot, data) {
            self.setUniqueEvent(evn, true);
            return self.trigger(evn, slot, data);
        };
        self.setUniqueEvent = function(evn, isUnique) {
            self._initEventName(evn);
            eventListener[evn].isUnique = isUnique===false ? false : true;
            return self;
        };
        self.eventHandlerCount = function(evn) {
            return (eventListener[evn] || {_functionList:[]})._functionList.length;
        };
        self.hasEventHandler = function(evn) {
            return self.eventHandlerCount(evn) > 0;
        };

                self._initEventName = function(evn) {
            if (!eventListener[evn]) {
                eventListener[evn] = new self.FunctionHook();
            }
            return eventListener[evn];
        };
        self._eventConditionFulfilled = function(condition, event) {
            if (condition === undefined) {
                return true;
            }
            if (typeof condition === 'string') {
                return event && event.slot && event.slot.id === condition;
            }
            try {
                return condition(event);
            } catch (e) {
                return condition;
            }
            return true;
        };
        self._runEventListener = function(func) {
            try {
                return func.apply(self);
            } catch (e) {
                return undefined;
            }
        };
    }).apply(self);
    (function() {
        function bodyBegin() {
            self.setUniqueEvent('body.begin', true);
            var done = false,
                animationFrame;
            if (doc.getElementsByTagName('body').length) {
                return self.trigger('body.begin');
            }
            if (win.requestAnimationFrame) {
                animationFrame = win.requestAnimationFrame(function() {
                    if (done || doc.getElementsByTagName('body').length === 0) { return; }
                    done = true;
                    win.cancelAnimationFrame(animationFrame);
                    self.trigger('body.begin');
                });
            }
            var interval = win.setInterval(function() {
                if (doc.getElementsByTagName('body').length === 0) { return; }
                if (done) { return win.clearInterval(interval); }
                done = true; 
                win.clearInterval(interval);
                self.trigger('body.begin');
            }, 20);
        }
        function bodyEnd() {
            self.on('body.end', function() { self.trigger('body.begin'); });
            self.setUniqueEvent('body.end', true);
            if (doc.readyState === 'complete') {
                return self.trigger('body.end');
            }
            if (doc.addEventListener) {
                doc.addEventListener('DOMContentLoaded', function() {
                    self.trigger('body.end');
                }, false);
            } else if (doc.attachEvent) {
                doc.attachEvent('onreadystatechange', function() {
                    if (doc.readyState !== 'complete') { return; }
                    self.trigger('body.end');
                });
            }
        }
        function pagePositionChange() {
            var minWait = 100,
                timeoutHandler = null,
            _;
            function positionChangeHandler() {
                timeoutHandler = null;
                self.trigger('page.positionchange');
            }
            function positionChangeRunner() {
                if (timeoutHandler) { return; }
                timeoutHandler = win.setTimeout(positionChangeHandler, minWait);
            }
            win.addEventListener('resize', positionChangeRunner, false);
            doc.addEventListener('scroll', positionChangeRunner, true);
        }

                self.on('initialize.begin', function() {
            bodyBegin.apply(self);
            bodyEnd.apply(self);
            pagePositionChange.apply(self);
        });
    }).apply(self);
    (function() {
        self.Module = function(name, func) {
            if (this===self) {
                return self.Module.modules[name];
            }
            if (self.Module.modules[name]) {
                throw new Error('Module "' + name + '" already defined');
            }
            self.Module.modules[name] = this;
            if (typeof func === 'function') {
                this.exec(func);
            }
        };
        self.Module.modules = {};
        self.Module.prototype._locals = {};
        self.Module.prototype._globals = {};
        self.Module.prototype._errors = {};
        self.Module.prototype.exec = function(func) {
            func.apply(this);
            return this;
        };
        self.Module.prototype._registerMember = function(name, member, reference, collection, desc) {
            if (name in reference) {
                throw new Error(desc + ' member "' + name + '" already defined');
            }
            reference[name] = typeof member === 'function' ? member.bind(reference) : member;
            collection[name] = reference[name];
            return this;
        };
        self.Module.prototype.extendBaseObject = function(name, member) {
            return this._registerMember(name, member, self, this._globals, 'Global');
        };
        self.Module.prototype.set = self.Module.prototype.extend = function(name, member) {
            return this._registerMember(name, member, this, this._locals, 'Local');
        };
        self.Module.prototype.createError = function(name, fileName, properties) {
            this._errors[name] = new self.Error(name, 'module/'+this.name, fileName, properties);
            return this;
        };
        self.Module.prototype.getError = function(name, message, data, positionHint, lineNumber, columnNumber) {
            return new (this._errors[name] || new self.Error(name, 'module/'+this.name, '[unknown].js'))(message, data, positionHint, lineNumber, columnNumber);
        };
        self.Module.prototype.throwError = function(name, message, data, positionHint, lineNumber, columnNumber) {
            throw this.getError(name, message, data, positionHint, lineNumber, columnNumber);
        };
        self.Module.logError = function(e) {
            self.log.error('Error in Module:', e);
        };
    }).apply(self);
    /**
     * saves a function to be called when AdService is available. 
     Very usefull when requesting the AsService asynchronously.
     * @function push
     * @param {function} func - the function to be executed.
     * @example AdService.push(function() {
        AdService.on('contractAd', function(evt){
            evt.data.isContractAllowed = true;
        }); 
    });
     */
    self.push = function(func) {
        precalls.push(func);
    };
    self.on('initialize.begin', function() {
        self.push = function() {
            each(arguments, function(i, func) {
                if (typeof func === 'string') {
                    return func === '#cleanup' ? self.cleanup() : self.ad(func);
                }
                try { func.apply(self); }
                catch (e) { self.log.error('Error calling function via AdService.push():', e, func); }
            });
        };
        self.push.apply(self, precalls);
    });
    (function() {
        var queues = {};

                function execute(func, name, reason) {
            var data = {name: name, reason: reason};
            try {
                func(data);
            } catch (e) {
                self.log.error('Error in waiting queue function', e, arguments, data, this);
            }
        }

                self.registerWaitingQueue = function(name) {
            queues[name] = queues[name] || [];
            return self;
        };
        self.waitFor = function(name, func) {
            if (!queues[name]) {
                execute(func, name, queues.hasOwnProperty(name) ? 'completed' : 'noqueue');
                return self;
            }
            queues[name].push(func);
            return self;
        };
        self.waitingComplete = function(name) {
            var queue = queues[name];
            queues[name] = false;
            each(queue, function(i, func) {
                execute(func, name, 'processing');
            });
            return self;
        };
        self.isQueueCompleted = function(name) {
            return queues[name] === false;
        };

                self.getQueue = function(name) {
            return name ? queues[name] : queues;
        };
    }).apply(self);

    (function() {
        self.info = {};
        var _infoStack = {};

                self._determineInfo = function(name) {
            var data = {
                info: name,
            _:0};
            self.trigger('determineSystem.begin', data);
            try {
                self.info['_'+name] = _infoStack[name]();
            } catch (e) {
                self.info['_'+name] = {};
            }
            self.trigger('determineSystem.end', data);
        };
        self.registerInfo = function(name, func, isPersistent, options) {
            if (typeof name === 'string') {
                return self.registerInfo(extend({name:name, func:func, persistent:isPersistent}, options));
            }
            var data = defaults(name, {
                persistent: false,
                event: 'now',
                initial: {}
            });
            _infoStack[data.name] = data.func;
            self.info[data.name] = data.persistent
                            ? function() {  return self.info['_'+data.name]; }
                            : function() { self._determineInfo(data.name); return self.info['_'+data.name]; }
            ;
            self.info['_'+data.name] = data.initial;
            self.on(data.event, function() {
                self._determineInfo(data.name);
            });
        };
    }).apply(self);
    (function() {
        var ua = navigator.userAgent.toLowerCase();
        function findVersion(name) {
            return new Version((ua.match(new RegExp(name + '[/ ;](\\d+(?:\\.\\d+)?)')) || [])[1]);
        }
        function determine_ua() {
            var browser = (ua.match(['edge', 'msie', 'opr', 'firefox', 'seamonkey', 'aurora', 'iron', 'chrome', 'mobile safari', 'safari', 'opera'].join('|')) || [])[0],
                os      = (ua.match(['windows nt', 'windows phone', 'windows rt', 'windows', 'mac os', 'os x', 'android', 'iphone', 'ipad', 'ipod', 'blackberry', 'rim', 'linux'].join('|')) || [])[0];
            return {
                browser: {name:browser, version:findVersion(browser)},
                os:      {name:os,      version:findVersion(os)}
            };
        };
        self.registerInfo('ua', determine_ua, true);
    }).apply(self);
    (function() {
        function determine_flash() {
            var versiontext;
            try {
                versiontext = win.navigator && win.navigator.plugins && win.navigator.plugins['Shockwave Flash']
                            ? win.navigator.plugins['Shockwave Flash'].description
                            : (win.ActiveXObject ? new ActiveXObject('ShockwaveFlash.ShockwaveFlash').GetVariable('$version') : '0.0');
            } catch (e) {
                self.log.error('Error in determine_flash()', e, arguments, this);
            }
            var majorminor = +(((versiontext||'').match(/\d+(?:\.\d+)?/) || [0])[0]);
            var version = new Version(majorminor);
            version.installed = !!parseInt(majorminor, 10);
            return version;
        };
        self.registerInfo('flash', determine_flash, true);
    }).apply(self);
    (function() {
        function determine_view() {
            return {
                screen: {width: screen.width, height: screen.height},
                window: {
                    width: win.outerWidth,
                    height: win.outerHeight,
                    x: ('screenLeft' in win) ? win.screenLeft : win.screenX,
                    y: ('screenTop' in win) ? win.screenTop : win.screenY
                },
                viewport: {width: win.innerWidth, height: win.innerHeight}
            };
        };
        self.registerInfo('view', determine_view, false);
    }).apply(self);
    (function() {
        var ua = navigator.userAgent.toLowerCase();
        function determine_device() {
            return {
                devicetype: /android(?!.*mobile)|ipad|kindle|playbook|\btab|surface/.test(ua)
                    ? 'tablet'
                    : /mobi|windows phone|iphone|blackberry/.test(ua)
                        ? 'mobile'
                        : 'desktop',
                retina: 'matchMedia' in win && (win.matchMedia('(-webkit-min-device-pixel-ratio: 2)') || 0).matches,
                touchscreen: 'ontouch' in doc.documentElement  
            };
        }
        self.registerInfo('device', determine_device, true);
    }).apply(self);
    (function() {
        function determine_view() {
            return {
                canvas: 'getContext' in doc.createElement('canvas'),
            _:0};
        };
        self.registerInfo('features', determine_view, true);
    }).apply(self);
    (function() {
        function determine_connection() {
            return {
                type: ['?', 'eth', 'wifi', '2g', '3g', '4g'][(navigator.connection || 0).type || 0] || '?',
                speed: undefined
            };
        }
        self.registerInfo('connection', determine_connection, true);
    }).apply(self);

    (function() {
        self.ObjectList = function() {
            this.list = {};
            this.register = function(obj) {
                this.list[obj.id] = obj;
            };
            this.getList = function() {
                return this.list;
            };
            this.get = function(id) {
                return this.list[id];
            };
        };
    }).apply(self);
    (function() {
        var AdServerList = new self.ObjectList(),
            paramOverride = {global:{}, slots:{}, secured:{}},
            urlParams = location.search.substr(1).split('&'),
        _;

            each(urlParams, function(i, param) {
            var name = param.substr(0, param.indexOf('=')),
                value = param.substr(param.indexOf('=')+1),
            _;
            if (name.indexOf(Const.OVERRIDE_PARAM_PREFIX) !== 0) { return; }
            var nameParts = name.substr(Const.OVERRIDE_PARAM_PREFIX.length).split(':');
            if (nameParts[1]) {
                paramOverride.slots[nameParts[0]] = paramOverride.slots[nameParts[0]] || {}
                paramOverride.slots[nameParts[0]][nameParts[1]] = value;
            } else {
                paramOverride.global[nameParts[0]] = value;
            }
        });

            self.AdServer = function(id, config, params) {
            if (this === self) {
                return id instanceof self.AdServer ? id : (AdServerList.get(id) || new self.AdServer(id, config, params));
            }
            this.id = id;
            this.activated = false;
            this[securedSymbol] = {
                setSecuredParam: function(name, value) {
                    paramOverride.secured[name] = value;
                },
                getSecuredParam: function() { return paramOverride.secured; }
            };
            this.setConfig(extend({
                enabled: true,
                supportRefresh: true,
                protocol: '//',
                host: '',
                path: '',
                sepQuery: '?',
                sepParams: '&',
                sepNameValue: '=',
                sepFragment: '#',
                paramOrder: {
                    begin:  [],
                    end:    [],
                    ignore: []
                },
                requestTypes: {
                    javascript: undefined,
                    iframe: undefined,  
                    friendlyIframe: undefined,
                    json: undefined,
                    safeFrame: undefined
                },
                evenIfEmpty: [],
                checkParams: undefined, 
                nonContentElements: []
            }, config));
            this.setParam(params);

                if (typeof this.getConfig('init') === 'function') {
                try {
                    this.getConfig('init').bind(this)();
                } catch (e) {
                    self.log.error('Error in initialization of AdServer "' + id + '"', e, this);
                }
            }

                this.slotConfig = {};
            this.slotParams = {};

                this.AdServer = self.AdServer.bind(self);
            AdServerList.register(this);
            if (this.config.probableDefault && !self.getDefaultAdServer()) {
                self.setDefaultAdServer(this);
            }
        };

        self.AdServer.getList = function() {
            return AdServerList.getList();
        };

        self.AdServer.prototype.activate = function() {
            if (this.activated) { return this; }
            this.activated = true;
            if (typeof this.config.firstUse === 'function') {
                this.config.firstUse.bind(this)();
            }
            return this;
        };
        self.AdServer.prototype.firstUse = function() {
        };
        self.AdServer.prototype.configure = function(config) {
            self.log.legacy('AdService.AdServer(...).configure(...) is deprecated. Please use AdService.AdServer(...).setConfig(...) instead.');
            return this.setConfig(config);
        };
        self.AdServer.prototype.setParam = function(params) {
            if (typeof params !== 'object' || params === null) {
                var tmp = {};
                tmp[arguments[0]] = arguments[1];
                params = tmp;
            }
            var data = {
                server: this,
                params: params,
            _:0};
            self.trigger('server.setparam', data);
            this.params = extend(this.params || {}, data.params);
            return this;
        };
        self.AdServer.prototype.setConfig = function(config) {
            if (typeof config === 'string') {
                var tmp = {};
                tmp[arguments[0]] = arguments[1];
                config = tmp;
            }
            var data = {
                server: this,
                config: config,
            _:0};
            self.trigger('server.setconfig', data);
            this.config = extend(this.config || {}, data.config);
            return this;
        };
        self.AdServer.prototype.enable = function() {
            this.setConfig('enabled', true);
            self.trigger('server.enabled', self._getCurrentAdSlot(), {server:this});
            return this;
        };
        self.AdServer.prototype.disable = function() {
            this.setConfig('enabled', false);
            self.trigger('server.disabled', self._getCurrentAdSlot(), {server:this});
            return this;
        };
        self.AdServer.prototype.isEnabled = function() {
            return this.getConfig('enabled');
        };
        self.AdServer.prototype.setSlotParam = function(slot, key, value) {
            var slotParams = {};
            if (typeof slot === 'string') {
                if (typeof key === 'string') {
                    var tmp = {};
                    tmp[key] = value;
                    slotParams[slot] = tmp;
                } else {
                    slotParams[slot] = key;
                }
            } else {
                slotParams = slot;
            }
            this.slotParams = extend(this.slotParams, slot);
            return this;
        };
        self.AdServer.prototype.setSlotConfig = function(slot, key, value) {
            var slotConfig = {};
            if (typeof slot === 'string') {
                if (typeof key === 'string') {
                    var tmp = {};
                    tmp[key] = value
                    slotConfig[slot] = tmp;
                } else {
                    slotConfig[slot] = key
                }
            } else {
                slotConfig = slot;
            }

                this.slotConfig = extend(this.slotConfig, slot);
            return this;
        };
        self.AdServer.prototype.getUrl = function(slot, requestMethod) {
            slot = self._getAdSlot(slot);
            var data = {
                server: this,
                slot: slot,
                requestMethod: requestMethod,
            _:0};
            self.trigger('server.getUrl', slot, data);
            var url = this._getUrl(slot, requestMethod);
            return url;
        };
        self.AdServer.prototype.getConfig = function(key, defaultValue) {
            if (typeof key !== 'undefined') {
                return this.config.hasOwnProperty(key) ? this.config[key] : defaultValue;
            } else {
                return this.config;
            }
        };
        self.AdServer.prototype.getParams = function() {
            var params = extend({}, this.params || {}, paramOverride.global || {}, paramOverride.secured || {});
            each(params, function(key, value) {
                if (typeof params[key] === 'function') {
                    params[key] = params[key](this);
                }
            });
            return params;
        };
        self.AdServer.prototype.getParam = function(key, defaultValue) {
            if (key instanceof Array) {
                var result = {};
                var params = this.getParams();
                each(key, function(i, name) {
                    result[name] = params[name];
                });
                return result;
            }
            return this.getParams()[key] || defaultValue;
        };

            self.AdServer.prototype.getParamsForSlot = function(slot) {
            var params = extend({}, this.params || {}, slot.params || {}, paramOverride.global, paramOverride.slots[slot] || {}, paramOverride.secured || {});
            each(params, function(key, value) {
                if (typeof value === 'function') {
                    params[key] = params[key](slot);
                }
            });
            return params;
        };

            self.AdServer.prototype.getParamForSlot = function(slot, key, defaultValue) {
            return this.getParamsForSlot(slot)[key] || defaultValue;
        };

            self.AdServer.prototype._getUrl = function(slot, requestMethod) {
            var config = this.config;
            var params = this.getParams();
            var paramString = this._getParamString(params, slot);
            return config.protocol + config.host + '/' + config.path + config.sepQuery + paramString;
        };

        self.AdServer.prototype.getUrlParams = function(slot, requestMethod) {
            var params = this.getParamsForSlot(slot, requestMethod);
            params = this.prepareParamsForUrl ? this.prepareParamsForUrl(params, slot) : params;
            var config = this.config;

                var data = {
                    params: params,
                    keyList: [],
                    sortedParams: {},
                _:0},
                paramOrder = config.paramOrder,
            _;

            var evenIfEmpty = config.evenIfEmpty;
            for (var i=0, l=evenIfEmpty.length; i<l; i++) {
                if (typeof data.params[evenIfEmpty[i]] === 'undefined') {
                    data.params[evenIfEmpty[i]] = undefined;
                }
            }

                data.keyList = keys(data.params);
            self.trigger('server.getParams.begin', slot, data);

            var beginLength = paramOrder.begin.length;
            while (beginLength > 0) {
                var index = data.keyList.indexOf(paramOrder.begin[--beginLength]);
                if (index !== -1) {
                    data.keyList.unshift(data.keyList.splice(index, 1)[0]);
                }
            }

            for (var i=0, l=paramOrder.end.length; i<l; i++) {
                var index = data.keyList.indexOf(paramOrder.end[i]);
                if (index !== -1) {
                    data.keyList.push(data.keyList.splice(index, 1)[0]);
                }
            }

            for (var i=0, l=paramOrder.ignore.length; i<l; i++) {
                var index = data.keyList.indexOf(paramOrder.ignore[i]);
                if (index !== -1) {
                    data.keyList.splice(index, 1);
                }
            }

            var sortedParams = {};
            for (var i=0, l=data.keyList.length; i<l; i++) {
                sortedParams[data.keyList[i]] = data.params[data.keyList[i]];
            }

                data.sortedParams = sortedParams;
            self.trigger('server.getParams.end', slot, data);
            return data.sortedParams;
        };

            self.AdServer.prototype._getParamName = function(key, value, slot) {
            return key;
        };

            self.AdServer.prototype._getParamString = function(params, slot) {
            var paramStrings = [],
                config = this.config,
                server = this;
            each(params, function(key, value) {
                if (typeof value !== 'undefined' || config.evenIfEmpty.indexOf(key) !== -1 ) {
                    if (typeof value === 'function') {
                        value = value(slot);
                    }
                    paramStrings.push(server._getParamName(key, value, slot) + config.sepNameValue + Code.url(typeof value === 'undefined' ? '' : value));
                }
            });
            return paramStrings.join(config.sepParams);
        };
        self.AdServer.prototype.isEmptyAd = function(domNode) {
            var elements = ['script', 'style'].concat(this.getConfig('nonContentElements'));
            var hasContent = false;
            each(domNode.childNodes, function(i, node) {
                if (node.nodeType !== document.ELEMENT_NODE) { return; }
                hasContent = hasContent || !(elements.indexOf(node.nodeName.toLowerCase())+1);
            });
            return !hasContent;
        };
        self.AdServer.prototype.renderMeta = function(html, meta) {
            return html;
        };
        self.AdServer.prototype.newPageContext = function() {
            self.log.nyi('AdService.AdServer(\''+this.id+'\').newPageContext()');
            return this;
        };

            self.AdServer.prototype.getAdSize = function(domNode) {
            self.log.nyi('AdService.AdServer(\''+this.id+'\').getAdSize(domNode)');
            return {width:undefined, height:undefined};
        };

            self.AdServer.prototype.splitMultiResponse = function(domNode) {
            self.log.nyi('AdService.AdServer(\''+this.id+'\').splitMultiResponse()');
            return [];
        };

            self.AdServer.prototype.exportMetaData = function() {
            return this;
        };
        self.AdServer.prototype.importMetaData = function(data) {
        };

            self.AdServer.prototype.getAdFormByMetaData = function(meta, fallbackAllowed) {
            self.log.nyi('AdService.AdServer(\''+this.id+'\').getAdFormByMetaData()');
            return undefined;
        };

            self.AdServer.prototype.getEventsByMetaData = function(meta) {
            self.log.nyi('AdService.AdServer(\''+this.id+'\').getEventsByMetaData()');
            return undefined;
        };
        self.AdServer.prototype.isAlive = function() {
            self.log.nyi('AdService.AdServer(\''+this.id+'\').isAlive()');
            return new Promise(function(done, reject) { window.setTimeout(function() { return Math.random() < 0.5 ? done(true) : reject(false); }, 500 + Math.random()*1000)});
        };

            /**
         * @TODO comment! checks if adserver url is valid
         */
        self.AdServer.prototype.checkUrlValidity = function(url) {
            self.log.nyi('AdService.AdServer(\''+this.id+'\').checkUrlValidity()');
            return false;
        };

            self.AdServer.prototype.back = function() {
            return self;
        };

        self.getParams = function() {
            return self.getDefaultAdServer().getParams();
        };
        self.getParam = function(name) {
            if (name instanceof Array) {
                var result = {};
                var params = self.getDefaultAdServer().getParams();
                each(name, function(i, name) {
                    result[name] = params[name];
                });
                return result;
            }
            return self.getDefaultAdServer().getParams()[name];
        };
        self.setParam = function() { 
            var server = self.getDefaultAdServer();
            server.setParam.apply(server, arguments);
            return self;
        };


            }).apply(self);
    (function() {
        var AdSlotList = new self.ObjectList();

        self.AdSlot = function(id, config, params) {
            if (this === self) {
                return id instanceof self.AdSlot
                     ? id
                     : (id instanceof Node
                       ? self.findAdSlotByNode(id)
                       : (AdSlotList.get(id) || new self.AdSlot(id, config, params))
                     );
            }
            this.id = id;
            this.config = config || {};
            this.params = params || {};
            this.onetimeParams = {};
            this.sandboxAttributes = {
                'allow-forms': true,
                'allow-popups': true,
                'allow-popups-to-escape-sandbox': true,
                'allow-same-origin': true,
                'allow-scripts': true,
            };
            this.clones = [];
            this.parent = null;
            this.lastRequestedUrl = null;
            this.lastUsedAdHtml = null;
            this._pendingAdHtml = null;
            this.htmlQueue = [];
            this.fixedSize = {type: 'auto'};
            this.timeout = {id: undefined, note: '', callback: undefined};

                if (!this.config.hasOwnProperty('enabled')) {
                this.setConfig('enabled', self.getConfig('slot-enabled-default', true));
            }

                if (this.config.domNode) {
                this.setDomNode(this.config.domNode);
            }
            AdSlotList.register(this);
            if (!this.getConfig('enabled')) {
                self.trigger('slot.disabled', this);
            }
        };

        self.AdSlot.getList = function() {
            return AdSlotList.getList();
        };

            self.AdSlot.get = function(id) {
            self.log.deprecated('AdService.AdSlot.get("'+id+'"): Please use AdService.AdSlot("'+id+'") instead. The method .get() will be removed soon!');
            return AdSlotList.get(id) || new self.AdSlot(id);
        };

        self.AdSlot.getDomNodes = function() {
            var selectors = [];
            each(arguments, function(i, item) {
                var slotname = (item instanceof self.AdSlot || typeof item !== 'string')
                             ? item.id
                             : item;
                selectors.push('[' + self.getDataAttrName('slot') + '="' + Code.css(slotname) + '"]');
            });
            return dom(selectors.join(', '));
        };

        self.AdSlot.prototype.getDomNode = function() {
            return this.setDomNode(self.getConfig('slot-getdomnode-function')(this));
        };
        function getDomNode(slot) {
            return slot.domNode || self.AdSlot.getDomNodes(slot)[0];
        }
        self.setConfig('slot-getdomnode-function', getDomNode);

        self.AdSlot.prototype.setDomNode = function(domNode) {
            if (!domNode) { return; }
            this.domNode = domNode;
            this.domNode.adSlot = this;
            this.domNode.setAttribute(self.getDataAttrName('slot') + '-initialized', 'true');
            var paramRoot = self.getDataAttrName('param-'),
                slot = this,
            _;
            each(this.domNode.attributes, function(i, attr) {
                if (attr.nodeName.indexOf(paramRoot) < 0) { return; }
                slot.params[attr.nodeName.substr(paramRoot.length)] = attr.nodeValue;
            });
            return domNode;
        };

            self.AdSlot.prototype.getTarget = function() {
            return this.target || this.getDomNode();
        };
        self.AdSlot.prototype.setTarget = function(domNode) {
            this.target = domNode;
        };

            self.AdSlot.prototype.toString = function() {
            return this.id;
        };
        self.AdSlot.prototype.getParam = function(key, defaultValue) {
            if (key instanceof Array) {
                var result = {};
                var slot = this;
                each(key, function(i, name) {
                    result[name] = slot.getParam(name); 
                });
                return result;
            }
            if (typeof this.params[key] !== 'undefined') {
                if (typeof this.params[key] === 'function') {
                    return this.params[key](this);
                } else {
                    return this.params[key];
                }
            } else {
                return this.getAdServer().getParamForSlot(this, key, defaultValue);
            }
        };
        self.AdSlot.prototype.setParam = function(key, value) {
            if (typeof key === 'object') {
                var slot = this;
                each(key, function(key, value) {
                    slot.setParam(key, value);
                });
                return;
            }
            var data = {
                name: key,
                value: value,
            _:0};
            self.trigger('slot.setparam', this, data);
            this.params[data.name] = data.value;
            each(this.clones, function(i, clone) { clone.setParam(key, data.value); });
            return self;
        };
        self.AdSlot.prototype.setOnetimeParam = function(key, value) {
            if (typeof key === 'object') {
                var slot = this;
                each(key, function(key, value) {
                    slot.setOnetimeParam(key, value);
                });
                return;
            }
            var data = {
                name: key,
                value: value,
                onetime: true,
            _:0};
            self.trigger('slot.setparam', this, data);
            this.onetimeParams[data.name] = data.value;
            each(this.clones, function(i, clone) { clone.setOnetimeParam(key, data.value); });
            return self;
        };
        self.AdSlot.prototype.clearOnetimeParams = function() {
            this.onetimeParams = {};
        };

            self.AdSlot.prototype.getConfig = function(key, defaultValue) {
            return this.config.hasOwnProperty(key) ? this.config[key] : defaultValue;
        };
        self.AdSlot.prototype.setConfig = function(key, value) {
            var data = {
                name: key,
                value: value,
            _:0};
            switch (data.name) {
                case 'adserver':
                    data.value = self.AdServer(data.value);
                    break;
                default:
                    break;
            }
            self.trigger('slot.setconfig', this, data);
            this.config[data.name] = data.value;
            each(this.clones, function(i, clone) { clone.setConfig(key, data.value); });
            return self;
        };

            /**
         * setSandboxAttributes(false) -- no sandbox attributes
         * setSandboxAttributes({foo:true, bar:false}) -- foo, but no bar, and all default (=previous) values
         * this.sandboxAttribute = {} => no sandbox attribute (Object.keys(this.sandbox).length===0)
         * this.sandboxAttribute = {...:false} => empty sandbox attribute
         * this.sandboxAttribute = {...:true} => filled sandbox attribute
         */
        self.AdSlot.prototype.setSandboxAttributes = function(attr) {
            if (attr === false) {
                this.sandboxAttributes = {};
                return self;
            }
            this.sandboxAttributes = extend(this.sandboxAttributes, attr);
            return self;
        };
        self.AdSlot.prototype.getSandboxAttributeValue = function() {
            var attr = Object.keys(this.sandboxAttributes).filter(function(key) {
                return this.sandboxAttributes[key];
            }.bind(this));
            return attr.join(' ');
        };
        self.AdSlot.prototype.getSandboxAttribute = function() {
            if (Object.keys(this.sandboxAttributes).length) {
                return ' sandbox="' + this.getSandboxAttributeValue() + '"';
            }
            return '';
        };

        self.AdSlot.prototype.getAdServer = function() {
            return (typeof this.config.adserver !== 'undefined') ? self.AdServer(this.config.adserver) : self.getDefaultAdServer();
        };
        self.AdSlot.prototype.setAdServer = function(adserver) {
            this.setConfig('adserver', adserver);
        };
        self.AdSlot.prototype.enable = function() {
            this.setConfig('enabled', true);
            self.trigger('slot.enabled', this);
            return this;
        };
        self.AdSlot.prototype.disable = function() {
            this.setConfig('enabled', false);
            self.trigger('slot.disabled', this);
            return this;
        };
        self.AdSlot.prototype.isEnabled = function() {
            return this.getConfig('enabled', true);
        };
        self.AdSlot.prototype.isEmpty = function() {
            return this.getAdServer().isEmptyAd(this.getDomNode());
        };
        self.AdSlot.prototype.getUrl = function(requestMethod, callback) {
            if (typeof requestMethod === 'function') {
                callback = requestMethod;
                requestMethod = undefined;
            }
            var server = this.getAdServer().activate();
            if (typeof callback === 'function') {
                function sendResult() {
                    var auctionResult = self.Auction.Api(self.getAuctionConfig().scriptapi).getSlotResult(this.id);
                    callback(server.getUrl(this, requestMethod));
                }
                return self.waitFor('auction.finished', sendResult.bind(this)), undefined;
            }
            var url = server.getUrl(this, requestMethod);
            return url;
        };
        self.AdSlot.prototype.getAdSize = function(doc) {
            var server = this.getAdServer();
            return server.getAdSize(doc || this.domNode);
        };
        self.AdSlot.prototype.setFixedSize = function(width, height) {
            if (width && height) {
                this.fixedSize.type = 'fixed';
                this.fixedSize.width = width;
                this.fixedSize.height = height;
            } else if (width === false) {
                this.fixedSize.type = 'pagecontrol';
            } else {
                this.fixedSize.type = 'auto';
            }
            return this;
        };
        self.AdSlot.prototype.getVisibleFraction = function() {
            var dom = this.getDomNode();
            if (!dom || !dom.getBoundingClientRect) { return 0; }
            var rect = dom.getBoundingClientRect(),
                winrect = {
                    width: win.innerWidth || win.clientWidth,
                    height: win.innerHeight || win.clientHeight
                },
                rectSize = (rect.width || rect.right-rect.left) * (rect.height || rect.bottom-rect.top),
                areaSize = (Math.min(rect.right, winrect.width) - Math.max(rect.left, 0)) * (Math.min(rect.bottom, winrect.height) - Math.max(rect.top, 0)),
            _;
            self.log.level('adreq', '[AdSlot.getVisibleFraction]', 'slot', this.id, 'rect', rect, 'winrect', winrect, 'rectSize', rectSize, 'areaSize', areaSize, '+(rect.left >= 0 && rect.right <= winrect.width && rect.top >= 0 && rect.bottom <= winrect.height)', +(rect.left >= 0 && rect.right <= winrect.width && rect.top >= 0 && rect.bottom <= winrect.height));
            return rectSize ? areaSize / rectSize : +(rect.left >= -2 && Math.floor(rect.right)-2 <= winrect.width && rect.top >= -2 && Math.floor(rect.bottom)-2 <= winrect.height);
        };
        self.AdSlot.prototype.isVisible = function(minFraction) {
            var preCheck = this.getConfig('visibility-precheck', this.getAdServer().getConfig('visibility-precheck', self.getConfig('visibility-precheck')));
            if (typeof preCheck === 'function') {
                try {
                    var result = preCheck(this, minFraction);
                    if (typeof result === 'boolean') {
                        return result;
                    }
                } catch (e) {
                    self.log.error('Error in function supplied for AdService.AdSlot(\''+this.id+'\').setConfig(\'visibility-precheck\')', e, arguments, this);
                }
            }
                var lookahead = self.getConfig('visibility-lookahead', false);
                if (lookahead && (typeof minFraction !== 'boolean' || !minFraction)) {
                    var domnode = this.getDomNode();
                    self.log.level('adreq', '[AdSlot.isVisible lookahead]', 'slot', this.id, 'lookahead', self.getConfig('visibility-lookahead', false), 'domnode', domnode ? domnode.getBoundingClientRect().top <= win.pageYOffset + win.innerHeight + lookahead : false);
                    return domnode ? domnode.getBoundingClientRect().top <= win.pageYOffset + win.innerHeight + lookahead : false;
                }
                minFraction = undefined;
            self.log.level('adreq', '[AdSlot.isVisible end]', 'slot', this.id, 'preCheck', preCheck, 'minFraction', minFraction || self.getConfig('visibility-minimum-fraction', 0.5));
            return this.getVisibleFraction() >= (minFraction || self.getConfig('visibility-minimum-fraction', 0.5));
        };
        self.AdSlot.prototype.clone = function(id, config, params) {
            var slot = new self.AdSlot(id, config, params);
            slot.parent = this;
            slot.config = extend(slot.config, this.config);
            slot.params = extend(slot.params, this.params);
            this.clones.push(slot);
            return slot;
        };

            self.AdSlot.prototype.queueAdHtml = function(html, type) {
            this.htmlQueue.push({html:html, type:type});
            return this;
        };
        self.AdSlot.prototype.hasQueuedAdHtml = function() {
            return this.htmlQueue.length > 0;
        };
        self.AdSlot.prototype.getQueuedAdHtml = function() {
            var data = this.htmlQueue.shift();
            this._pendingAdHtml = data.html;
            return data.html;
        };
        self.AdSlot.prototype.getNextQueuedAdType = function() {
            return (this.htmlQueue[0] || [{}]).type;
        };

        self.AdSlot.prototype.empty = function() {
            var slot = this;
            return this.modify('empty', function(data) { data.domNode.innerHTML = ''; });
        };
        self.AdSlot.prototype.kill = function() {
            var slot = this;
            return this.modify('kill', function(data) { data.domNode.parentNode.removeChild(data.domNode); }, function(data) { slot.disable(); });
        };
        self.AdSlot.prototype.hide = function(method) {
            var slot = this;
            switch (method) {
                case 'visibility':
                    method = function(data) { data.domNode.style.visibility = 'hidden'; };
                    break;
                case 'display':
                default:
                    if (typeof method !== 'function') {
                        method = function(data) { data.domNode.style.display = 'none'; };
                    }
            }
            return this.modify('hide', method, function(data) { slot.disable(); });
        };
        self.AdSlot.prototype.show = function(method) {
            var slot = this;
            switch (method) {
                case 'visibility':
                    method = function(data) { data.domNode.style.visibility = 'visible'; };
                    break;
                case 'display':
                    method = function(data) { data.domNode.style.display = ''; if (!data.domNode.offsetHeight) { data.domNode.style.display = 'inline-block'; } };
                    break;
                default:
                    if (typeof method !== 'function') {
                        method = function(data) { data.domNode.style.visibility = 'visible'; data.domNode.style.display = ''; if (!data.domNode.offsetHeight) { data.domNode.style.display = 'inline-block'; } };
                    }
            }
            return this.modify('show', method, function(data) { slot.enable(); });
        };
        self.AdSlot.prototype.modify = function(action, func, toggleFunc) {
            var slot = this;
            var data = {
                    action: action, 
                    domNode: slot.getDomNode(),
                    method: func,
                    autoToggleEnabled: true,
                _:0},
            _;
            self.trigger('slot.' + action.toLowerCase(), slot, data);
            if (data.domNode) {
                try {
                    data.method(data);
                    if (toggleFunc && data.autoToggleEnabled) {
                        toggleFunc(data);
                    }
                } catch (e) {
                    self.log.error('Error in function supplied for AdService.modifySlot(slot, \''+action+'\', func, toggleFunc)', e, arguments, data, this);
                }
            }
            return this;
        };

        self.AdSlot.prototype.resize = function(width, height, elements) {
            if (this.fixedSize.type === 'pagecontrol') { return; }
            if (this.fixedSize.type === 'fixed') {
                width = this.fixedSize.width;
                height = this.fixedSize.height;
            }
            if (typeof width !== 'undefined') {
                this.domNode.style.width = width + 'px';
            }
            if (typeof height !== 'undefined') {
                this.domNode.style.height = height + 'px';
            }
            each(elements, function(i, element) {
                width && (element.style.width = width + 'px');
                height && (element.style.height = height + 'px');
            });
        };

        self.AdSlot.prototype.setTimeout = function(time, note, callback) {
            win.clearTimeout(this.timeout.id);
            if (typeof note === 'function') {
                callback = note;
                note = undefined;
            }
            this.timeout.note = note || 'deferred';
            this.timeout.callback = callback;
            this.timeout.id = win.setTimeout(this.timeoutReached.bind(this), time);
            return this;
        };
        self.AdSlot.prototype.timeoutReached = function() {
            var timeout = extend({}, this.timeout);
            this.clearTimeout();
            if (timeout.callback) {
                return timeout.callback.call(this);
            }
            AdService.ad(this.id);
        };
        self.AdSlot.prototype.clearTimeout = function(note) {
            if (note && note !== this.timeout.note) { return false; }
            this.timeout = {
                id: win.clearTimeout(this.timeout.id),
                note: '',
                callback: undefined
            };
            return true;
        };
        self.AdSlot.prototype.isDeferred = function() {
            return this.timeout.note;
        };

        self.AdSlot.prototype._metaData = [];
        self.AdSlot.prototype.clearMetaData = function() {
            this._metaData = [];
            return this;
        };
        self.AdSlot.prototype.addMetaData = function(meta) {
            this._metaData.push(meta);
            return this;
        };
        self.AdSlot.prototype.getMetaData = function() {
            return this._metaData;
        };


        self.AdSlot.prototype.getContainerWidth = function() {
            var node = this.getDomNode();
            return node ? node.offsetWidth : undefined;
        };

            self.AdSlot.prototype.getCurrentUrl = function() {
            return this.lastRequestedUrl || this.getUrl();
        };

        self.findAdSlots = function(rootNode) {
            var attrName = self.getDataAttrName('slot'),
                nodes = dom('[' + attrName + ']', rootNode);
            each(nodes, function(index, node) {
                if (node.adSlot) { return; }
                new self.AdSlot(node.getAttribute(attrName), {domNode: node});
            });
            return nodes;
        };

            self.findAdSlotByNode = function(node) {
            var attrName = self.getDataAttrName('slot'),
                origNode = node,
            _;
            while (!node.hasAttribute(attrName) && node !== doc.documentElement) {
                node = node.parentNode;
            }
            return node.hasAttribute(attrName) ? self.AdSlot(node.getAttribute(attrName)) : self.AdSlot(origNode.id);
        };

            self.getVisibleSlots = function(minFraction) {
            var slots = self.AdSlot.getList(),
                visible = [],
            _;
            each(slots, function(i, slot) {
                if (slot.isVisible(minFraction)) {
                    visible.push(slot);
                }
            });
            return visible;
        };

            self.on('ad.requested', function(evt) {
            if (evt.slot._pendingAdHtml) {
                evt.slot.lastUsedAdHtml = evt.slot._pendingAdHtml;
                evt.slot._pendingAdHtml = null;
            } else {
                evt.slot.lastRequestedUrl = evt.data.url;
            }
        });


            }).apply(self);

    /**
       -------------------------------------------------------------------------------------------
       AdPlayer v2.0.2.FINAL (FINAL.101512)
       Authors: christopher.sancho@adtech.com
                felix.ritter@adtech.com
                ingrid.graefen@sevenonemedia.de
                marius.naumann@bauermedia.com
                anton.parsons@adition.com
                andreas.berenz@adition.com
                o.wagner@raumobil.de

                       -------------------------------------------------------------------------------------------

             This file is part of AdPlayer v2.0.2.FINAL (FINAL.101512).
       AdPlayer is free software: you can redistribute it and/or modify
       it under the terms of the GNU General Public License as published by
       the Free Software Foundation, either version 3 of the License, or
       (at your option) any later version.

            AdPlayer is distributed in the hope that it will be useful,
       but WITHOUT ANY WARRANTY; without even the implied warranty of
       MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
       GNU General Public License for more details.

            You should have received a copy of the GNU General Public License
       along with AdPlayer.  If not, see <http://www.gnu.org/licenses/>.

            --------------------------------------------------------------------------------------------
    */
    if(!window.$ADP){$ADP={}}$ADP.Registry=$ADP.Registry||{data:{},translationFile:false,wait:2000,LAST:"LAST",MAIN:"MAIN",POPUP:"POPUP",FRIENDLY_IFRAME:"FRIENDLY_IFRAME",FOREIGN_IFRAME:"FOREIGN_IFRAME",POSTMESSAGE_SEARCH:"POSTMESSAGE_SEARCH",publisherInfo:undefined,register:function(b,a){this._register(b,a,false)},_register:function(e,c,b){if(!c){c={}}if(!this.data[e]){this.data[e]={items:[]}}var d={};for(var a in c){switch(a){case"domId":this.data[e][a]=c[a];break;case"header":case"footer":case"title":case"text":case"url":case"linkText":case"usePopup":case"renderCloseButton":d[a]=c[a];break;default:break}}if(!b){this.data[e].items.push(d)}else{this.data[e].items.unshift(d)}$ADP.Util.log('Registered item with title "'+c.title+'" for ID '+e)},unregister:function(a){if(!this.data[a]){return}delete this.data[a]},getById:function(b){var a=[];if(this.data[b]){a=this.data[b].items||[]}return a},pullById:function(b){var a=this.getById(b);this.unregister(b);return a},getDOMId:function(a){if(this.data[a]){return this.data[a].domId}},hasId:function(a){return this.data[a]?true:false},setPublisherInfo:function(a){if(typeof this.publisherInfo==="undefined"){this.publisherInfo=a}},checkParentAccess:function(c){var b;var a=function(g){try{return Boolean(g.$ADP)}catch(f){return false}};try{if(c.parent.location.href==undefined){b=this.FOREIGN_IFRAME}else{if(a(c.parent)){b=this.FRIENDLY_IFRAME}else{b=this.POSTMESSAGE_SEARCH}}}catch(d){b=this.FOREIGN_IFRAME}return b},getWindowChain:function(f){if(!this.data[f].windowChain){var e=this.checkParentAccess(window.parent);var c={1:{type:e,window:window,parent:window.parent}};if(window!=window.parent){var d=true;var b=2;var a=window.parent;var e;while(d){if(a==a.parent){e=this.checkParentAccess(a.parent);c[b]={type:e,window:a};d=false}else{e=this.checkParentAccess(a.parent);c[b]={type:e,window:a,parent:a.parent};a=a.parent}b++}if(window.opener){e=this.checkParentAccess(window.opener);c[b]={type:e,window:window,parent:window.opener}}}else{if(window.opener){e=this.checkParentAccess(window.opener);c[2]={type:e,window:window,parent:window.opener}}}this.data[f].windowChain=c}return this.data[f].windowChain},checkAndReducePostMessageCounter:function(a){this.data[a].postMessageCounter--;if(this.data[a].postMessageCounter==0){clearTimeout(this.data[a].postMessageTimeout);this.submitPrivacy(a)}},registerParentItems:function(c,b){if(!b){b=[]}if(!this.data[c]){return}if(this.data[c].iframeSearch&&this.data[c].iframeSearch.timeoutId){clearTimeout(this.data[c].iframeSearch.timeoutId)}b.reverse();for(var a in b){$ADP.Registry._register(c,b[a],true)}},createPlayer:function(a,g){$ADP.Util.log("$ADP.Registry.createPlayer called for ID "+a);if(!g){g={}}var e=g.header||undefined;var i=g.footer||undefined;var h=this.publisherInfo||"";var c=g.domId;var f=g.position||"top-right";var b=g.usePopup||true;var d=g.renderCloseButton==false?false:true;if(!this.data[a]){this.data[a]={domId:null,items:[]}}if(c){this.data[a].domId=c}c=this.getDOMId(a);var j=$ADP.Player(a,{domId:c,position:f,header:e,footer:i,publisherInfo:h,usePopup:b,renderCloseButton:d});j.inject();this.data[a].player=j;$ADP.Util.log("AdPlayer created for ID "+a);return j},generateId:function(){var a;do{a=parseInt(Math.random()*100000000)}while(this.hasId(a));$ADP.Util.log("Adplayer generated ID "+a);return a},messageHandler:function(b){try{var f=$ADP.Message.parse(b.data),d=b.source,a="";if(d==window){return null}switch(f.type){case $ADP.Message.types.pullOBA:a=$ADP.Registry.getById(f.data);$ADP.Message.send(d,$ADP.Message.types.pullOBA_ACK,{id:f.data,items:a});break;case $ADP.Message.types.unRegOBA:a=$ADP.Registry.unregister(f.data);break;case $ADP.Message.types.pullOBA_ACK:if(f.data.id&&f.data.items&&f.data.items.length){$ADP.Registry.registerParentItems(f.data.id,f.data.items);$ADP.Message.send(d,$ADP.Message.types.unRegOBA,f.data.id);$ADP.Registry.checkAndReducePostMessageCounter(f.data.id)}break}}catch(c){$ADP.Util.log("Received Message",b," Rejected ",c)}},getItems:function(e){var b=this.data[e].items;var a=[];for(var d=0;d<b.length;d++){if(b[d].usePopup==false){this.data[e].player.usePopup=false}if(b[d].renderCloseButton==false){this.data[e].player.renderCloseButton=false}var c=$ADP.PrivacyInfo(b[d]);if(c.isValid()){a.push(c)}}return a},collectPrivacy:function(b){var c=true;if(this.data[b].items&&this.data[b].items.length){for(var f in this.data[b].items){if(this.data[b].items[f].usePopup==false){c=false}}}if(c){if(this.data[b].player.popup){this.data[b].player.popup.close()}try{var g="adp_info_"+Math.floor(Math.random()*100001);popwin=window.open("",g,"width=400,height=500,scrollbars=yes,location=0,menubar=0,toolbar=0,status=0")}catch(h){popwin=window.open("about:blank")}this.data[b].player.popup=popwin}if(this.data[b].player.items&&this.data[b].player.items.length){this.submitPrivacy(b)}else{var a=this.getWindowChain(b);var l=[];for(var d in a){var j;if(!a[d].parent||a[d].parent==window){}else{if(a[d].type==this.FOREIGN_IFRAME||a[d].type==this.POSTMESSAGE_SEARCH){l.push(a[d])}else{if(a[d].window&&a[d].window.name){try{j=$ADP.Util.JSON.parse($ADP.Util.atob(a[d].window.name.replace(/^[^-]+\-([A-Za-z0-9\+\/]+=?=?=?)$/,"$1")))}catch(h){}}if(!j){try{j=a[d].parent.$ADP.Registry.getById(b)}catch(h){}}if(j.length){$ADP.Registry.registerParentItems(b,j)}}}}if(l&&l.length){if(window.postMessage){this.initByPostMessage(b,l)}else{this.initByWindowName(b,l)}}else{this.submitPrivacy(b)}}},initByPostMessage:function(b,a){for(k in a){if(this.data[b].postMessageCounter){this.data[b].postMessageCounter++}else{this.data[b].postMessageCounter=1}$ADP.Message.send(a[k].parent,$ADP.Message.types.pullOBA,b)}this.data[b].postMessageTimeout=setTimeout(function(){$ADP.Registry.submitPrivacy(b)},1000)},initByWindowName:function(d,b){for(k in b){if(!b[k].window.name){return}try{var a=$ADP.Util.JSON.parse($ADP.Util.atob(b[k].window.name.replace(/^[^-]+\-([A-Za-z0-9\+\/]+=?=?=?)$/,"$1")));if(a.length){this.registerParentItems(d,a)}}catch(c){}}this.submitPrivacy(d)},submitPrivacy:function(a){if(!this.data[a]&&!this.data[a].player){return}if(!this.data[a].player.items||this.data[a].player.items.length){this.data[a].player.items=this.getItems(a)}this.data[a].player.showPrivacy.apply(this.data[a].player,[])},playerCmd:function(c,b,a){if(!b){return}if(!this.data[c]&&!this.data[c].player){return}if(!a){a=[]}this.data[c].player.items=this.getItems(c);if(typeof this.data[c].player[b]=="function"){this.data[c].player[b].apply(this.data[c].player,a)}},setTranslation:function(a){if(!this.translationFile&&a.href){this.translationFile=a.href}},init:function(){if(window.addEventListener){window.addEventListener("message",$ADP.Registry.messageHandler,false)}else{if(window.attachEvent){window.attachEvent("onmessage",$ADP.Registry.messageHandler)}}}};if(!$ADP.Player){$ADP.Player=function(b,a){return this instanceof $ADP.Player?this.init(b,a):new $ADP.Player(b,a)};$ADP.Player.prototype={attempts:0,maxAttempt:50,browserLanguage:undefined,documentCharset:undefined,translation:{de:{adchoices:"Datenschutzinfo",header:'<strong class="adp-header-strong">Informationen zu nutzungsbasierter Online-Werbung</strong><br/>In der vorliegenden Anzeige werden Ihre Nutzungsdaten anonym erhoben bzw. verwendet, um Werbung f&uuml;r Sie zu optimieren. Wenn Sie keine nutzungsbasierte Werbung mehr von den hier gelisteten Anbietern erhalten wollen, k&ouml;nnen Sie die Datenerhebung beim jeweiligen Anbieter direkt deaktivieren. Eine Deaktivierung bedeutet nicht, dass Sie k&uuml;nftig keine Werbung mehr erhalten, sondern, dass die Auslieferung durch den jeweiligen Dienstleister nicht anhand anonym erhobener Nutzungsdaten erfolgt.',footer:'Wenn Sie mehr &uuml;ber nutzungsbasierte Online-Werbung erfahren wollen, klicken Sie <a href="http://meine-cookies.org" target="_blank">hier</a>. Dort k&ouml;nnen Sie dar&uuml;ber hinaus auch bei weiteren Anbietern die Erhebung der Nutzungsinformationen deaktivieren bzw. aktivieren und den Status der Aktivierung bei unterschiedlichen Anbietern <a href="http://meine-cookies.org/cookies_verwalten/praeferenzmanager-beta.html" target="_blank">einsehen</a>.'},en:{adchoices:"AdChoices",header:'<strong class="adp-header-strong">Information about Online Behavioural Advertising</strong><br/>In the current ad your usage (behavioural) data are collected anonymously and used to optimize advertising for you. If you do not want to receive any more behavior-based advertising by the vendors listed here, you can &#8220;turn off&#8221;  the collection of data at the providers level directly. &#8220;Turn off&#8221; does not mean that you will not receive any advertisements in the future. It means that the current campaign is not delivered on the basis of behaviour data, collected on an anonymous way.',footer:'If you wish to learn more about online behavioural advertising, click <a href="http://www.youronlinechoices.eu/" target="_blank">here</a>. There you can also &#8220;turn off&#8221;  or &#8220;turn on&#8221; the collection from other providers. Furthermore you can check the status of data collection from different <a href="http://www.youronlinechoices.com/uk/your-ad-choices" target="_blank">providers</a>.'},fr:{adchoices:"Choisir sa pub"},nl:{adchoices:"Info reclamekeuze"},bg:{adchoices:"&#1042;&#1072;&#1096;&#1080;&#1103;&#1090; &#1080;&#1079;&#1073;&#1086;&#1088;"},cs:{adchoices:"Volby reklamy"},da:{adchoices:"Annoncevalg"},fi:{adchoices:"Mainokseni"},el:{adchoices:"&#927;&#953; &#948;&#953;&#945;&#966;&#951;&#956;&#943;&#963;&#949;&#953;&#962; &#956;&#959;&#965;"},it:{adchoices:"Scegli tu!"},nl:{adchoices:"Info"},no:{adchoices:"Annonsevalg"},pl:{adchoices:"Informacja"},ro:{adchoices:"Optiuni"},sk:{adchoices:"Va&#353;a vo&#318;ba"},es:{adchoices:"Gesti&#243;n anuncios"},sv:{adchoices:"Annonsval"}},init:function(b,a){this.id=b;this.domId=a.domId;this.translationFile=a.translation;this.header=a.header;this.footer=a.footer;this.publisherInfo=a.publisherInfo;this.position=a.position||"top-right";this.usePopup=!!a.usePopup;this.renderCloseButton=!!a.renderCloseButton;this.popup=!!a.popup;this.browserLanguage=$ADP.Util.getBrowserLanguage();this.documentCharset=$ADP.Util.getDocumentCharset()},getId:function(){return this.id},getDOMId:function(){return this.domId},getTranslationFile:function(){return $ADP.Registry.translationFile?$ADP.Registry.translationFile:false},getPosition:function(){return this.position||"top-right"},getHeader:function(){return(this.header||this.getText({type:"header"}))},getFooter:function(){return(this.footer||this.getText({type:"footer"}))},getPublisherInfo:function(){return(this.publisherInfo||"")},getPrivacyButtonText:function(){return this.getText({type:"adchoices"})},usePopupForPrivacyInfo:function(){return this.usePopup==false?false:true},renderCloseButtonForPrivacyInfo:function(){return this.renderCloseButton?true:false},hasPrivacyInfo:function(){return Boolean(this.items.length)},getPopup:function(){return this.popup},getPrivacyInfos:function(){return this.items},inject:function(){var e=this.getId();var f=this.getDOMId();var a=this.getPosition();if(!e){return}if(!f){if(window==window.top&&document.body){return}var c=document.createElement("DIV");c.id=f="iframe-button-"+Math.round(Math.random()*9999);document.body.insertBefore(c,document.body.firstChild)}var b=c||document.getElementById(f);if(b){b.innerHTML='<div id="adp-wrapper-'+e+'" class="adp-wrapper adp-'+a+'" style="z-index:99999999;" onmouseover="this.className += \' adp-admarker-hover\';" onmouseout="this.className = this.className.replace(/adp-admarker-hover/, \'\');"><div id="adp-admarker-'+e+'" class="adp-admarker" ><div id="adp-admarker-icon-'+e+'" class="adp-admarker-icon adp-'+a+'" onClick="$ADP.Registry.collectPrivacy('+e+');"></div><div id="adp-admarker-text-'+e+'" class="adp-admarker-text adp-'+a+'"  onClick="$ADP.Registry.collectPrivacy('+e+');">'+this.getPrivacyButtonText()+"</div></div>"}else{if(this.attempts>this.maxAttempts){$ADP.Util.log("Too many attempts for "+e+", "+f);return}else{++this.attempts;var d=this;setTimeout(function(){d.inject()},100)}}},getPanelHTML:function(){var a=this.getId();var h=this.getPosition();var g=this.getHeader();var p=this.getFooter();var n=this.getPublisherInfo();var m=this.getPrivacyInfos();var b=this.usePopupForPrivacyInfo();var r=!b?"$ADP.Registry.playerCmd("+a+",'hidePrivacy');":"window.close();";var d=this.renderCloseButtonForPrivacyInfo();var o="";for(var f=0;f<m.length;f++){var q=m[f];if(f!=0){o+="<br /><br />\n"}try{o+=q.render()}catch(l){}}var j="";j=j.concat('<div class="adp-panel-wrapper">');if(g!=""){j=j.concat('<div class="adp-panel-header">'+g+"</div>")}if(n!=""){j=j.concat('<div class="adp-panel-publisherinfo">'+n+"</div>")}j=j.concat('<div class="adp-panel-info">'+o+"</div>");if(p!=""){j=j.concat('<div class="adp-panel-footer">'+p+"</div>")}j=j.concat("</div>");var c="";if(!b||(b&&d)){c+='<div id="adp-panel-close-'+a+'" class="adp-panel-close" onClick="'+r+'">x</div>'}c+=j;return c},showPrivacy:function(){var h=this.getPosition();var d=this.getId();var e=this.usePopupForPrivacyInfo();function a(){var l=document.getElementById("adp-panel-"+d);if(!l){var m=document.getElementById("adp-wrapper-"+d);if(!m){return}var l=document.createElement("DIV");l.id="adp-panel-"+d;l.className="adp-panel adp-"+h;l.display="block";l.innerHTML=this.getPanelHTML();m.appendChild(l)}else{l.style.display="block"}}if(!e){var c=this.getPopup();if(c){c.close()}a.apply(this)}else{var i=this.getText({type:"adchoices"});var j=document.styleSheets;var b=this.getPopup();if(!b){a.apply(this)}else{var f=b.document;window.popwin=b;f.write('<!doctype html><html><head><meta charset="utf-8" /><title>'+i+"</title>");for(var g in j){if(j[g].href){f.write('<link rel="stylesheet" href="'+j[g].href+'">')}}f.write('</head><body class="adp-popup"><div class="adp-wrapper"><div class="adp-panel">');f.write(this.getPanelHTML());f.write("</div></div></body></html>");f.close();b.focus()}}},hidePrivacy:function(){var b=this.getId();var a=document.getElementById("adp-panel-"+b);if(a){a.style.display="none"}},getText:function(a){if(a.type){if(!(this.browserLanguage=="de"||this.browserLanguage=="en")&&!document.getElementById("adptranslation")&&this.getTranslationFile()){try{var b=document.createElement("script");b.type="text/javascript";b.async=true;b.id="adptranslation";b.src=this.getTranslationFile();b.charset="utf-8";document.getElementsByTagName("head")[0].appendChild(b);$ADP.Util.log("Try to load translation file: "+this.getTranslationFile())}catch(d){$ADP.Util.log("Failed to load translation file: "+d.message)}}var c;if(this.translation[this.browserLanguage]&&this.translation[this.browserLanguage][a.type]){c=this.translation[this.browserLanguage][a.type]}else{if($ADP.Player.adpTranslation&&$ADP.Player.adpTranslation[this.browserLanguage]&&$ADP.Player.adpTranslation[this.browserLanguage][a.type]){c=$ADP.Player.adpTranslation[this.browserLanguage][a.type]}}if(c&&(this.documentCharset=="UTF-8"||/^[\u0000-\u0080]+$/.test(c))){return c}else{return this.translation.en[a.type]}}}}}if(!$ADP.PrivacyInfo){$ADP.PrivacyInfo=function(a){return this instanceof $ADP.PrivacyInfo?this.init(a):new $ADP.PrivacyInfo(a)};$ADP.PrivacyInfo.prototype={init:function(a){this.valid=a.title&&a.linkText&&a.url?true:false;this.title=a.title;this.text=a.text;this.url=a.url;this.linkText=a.linkText;this.usePopup=!!a.usePopup},getTitle:function(){return this.title},getText:function(){return this.text},getURL:function(){return this.url},getLinkText:function(){return this.linkText},isValid:function(){return this.valid?true:false},usePopup:function(){return this.usePopup?true:false},render:function(){var e=$ADP.Util.safeString(this.getTitle());var d=$ADP.Util.safeString(this.getText());var b=$ADP.Util.safeString(this.getLinkText());var a=$ADP.Util.safeString(this.getURL());var c="";if(b){c+=b}if(a){c='<a href="'+a+'" target="_blank">'+c+"</a>"}if(d){c=d+"<br />"+c}if(e){c='<div class="adp-info-header">'+e+"</div>"+c}return c}}}$ADP.Message=$ADP.Message||{types:{nomsg:"NULL",pullOBA:"ADP.Registry.pullOBA",pullOBA_ACK:"ADP.Registry.pullOBA_ACK",unRegOBA:"ADP.Registry.unRegOBA",unRegOBA_ACK:"ADP.Registry.unRegOBA_ACK"},create:function(a,b){var d={type:a,data:b};try{if($ADP.Util.JSON&&typeof $ADP.Util.JSON.stringify=="function"){return $ADP.Util.JSON.stringify(d)}}catch(c){}return'{"type":"NULL"}'},parse:function(a){try{if($ADP.Util.JSON&&typeof $ADP.Util.JSON.parse=="function"){return $ADP.Util.JSON.parse(a)}}catch(b){}return $ADP.Message.create("NULL",{})},send:function(a,b,c){try{if(a&&a.postMessage){var f=$ADP.Message.create(b,c);a.postMessage(f,"*")}}catch(d){}}};$ADP.Util=$ADP.Util||{browserLanguage:null,documentCharset:null,JSON:window.JSON||{stringify:function(d,b){function a(e){var g=new Array(e.length);for(var f=0,h=e.length;f<h;f++){g[f]=c(e[f])}return g}function c(f,e,g){for(e in (g=f==""+{}&&[])&&f){g.push(c(e)+":"+c(f[e]))}return""+f===f?'"'+f.replace(/[\x00-\x19\\]/g,function(h){return"\\x"+h.charCodeAt().toString(16)})+'"':f&&f.length?"["+a(f)+"]":g?"{"+g+"}":f}return c(d)},parse:function(jsonstr){var JSON_object=null;try{JSON_object=!(/[^,:{}\[\]0-9.\-+Eaeflnr-u \n\r\t]/.test(jsonstr.replace(/"(\\.|[^"\\])*"/g,"")))&&eval("("+jsonstr+")")}catch(e){}return JSON_object}},btoa:function(g,f,j,i,h){for(f="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=h="";g.charAt(i|0)||(f="=",i%1);h+=f.charAt(63&j>>8-i%1*8)){j=j<<8|g.charCodeAt(i-=-0.75)}return h},atob:function(i,e,j,f,g,h,a){for(g=h=a="",e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";j=i.charAt(a++);~j&&(f=h%4?f*64+j:j,h++%4)?g+=String.fromCharCode(255&f>>(-2*h&6)):0){j=e.indexOf(j)}return g},log:function(){try{if(window.location&&window.location.search&&window.location.search.match(/adpdebug/)){$ADP.Util.log.history=$ADP.Util.log.history||[];$ADP.Util.log.history.push(arguments);if(typeof console!="undefined"){console.log(Array.prototype.slice.call(arguments))}}}catch(a){}},safeString:function(b){var a=b;a=a.split("<").join("&lt;");a=a.split(">").join("&gt;");return a},createIframeName:function(b){var a="";if(!window.postMessage){a=$ADP.Util.btoa($ADP.Util.JSON.stringify($ADP.Registry.pullById(b)))}return a},getBrowserLanguage:function(){if(!this.browserLanguage){if(navigator.language){this.browserLanguage=navigator.language}else{if(navigator.browserLanguage){this.browserLanguage=navigator.browserLanguage}else{this.browserLanguage="en"}}this.browserLanguage=/[a-z]+/i.exec(this.browserLanguage)[0];$ADP.Util.log("Detected Browser Language is: "+this.browserLanguage)}return this.browserLanguage?this.browserLanguage:"en"},getDocumentCharset:function(){if(!this.documentCharset){if(document.characterSet){this.documentCharset=document.characterSet}else{if(document.charset){this.documentCharset=document.charset}else{if(document.defaultCharset){this.documentCharset=document.defaultCharset}}}$ADP.Util.log("Detected document charset is: "+this.documentCharset)}return this.documentCharset}};$ADP.getVersion=$ADP.getVersion||function(){return{major:2,minor:0,patch:2,stage:"FINAL"}};if(!$ADP.init){$ADP.init=function(){$ADP.Registry.init()};$ADP.init()};
    (function() {
        var head = document.getElementsByTagName('head')[0],
            css = document.createElement('link')
        ;
        var style = document.createElement('style');
        var obaIconUrl = 'data:image/png;base64,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';
        style.innerText = 'body.adp-popup{margin:0;padding:10px;background-color:#FFF;color:#000;min-width: auto;}.adp-top-right{top:0;right:0;}.adp-top-left{top:0;left:0;}.adp-bottom-right{bottom:0;right:0;}.adp-bottom-left{bottom:0;left:0;}.adp-wrapper{position:absolute;}.adp-popup .adp-wrapper{position:relative;}div.adp-wrapper div.adp-panel{background:#fff;color:#000;border:1px solid #ccc;margin:0;padding:13px 8px 3px 8px;min-height:25px;width:310px;position:absolute;}.adp-popup div.adp-wrapper div.adp-panel{border:0;width:100%;max-width:380px;position:relative;padding:0;}div.adp-wrapper div.adp-panel,div.adp-wrapper div.adp-admarker{font-family:Arial,Verdana,Tahoma,sans-serif;font-size:11px;line-height:1.3;font-weight:normal;font-style:normal;text-align:left;color:#000;}div.adp-wrapper div.adp-panel .adp-panel-header,div.adp-wrapper div.adp-panel .adp-panel-info,div.adp-wrapper div.adp-panel .adp-panel-publisherinfo,div.adp-wrapper div.adp-panel .adp-panel-footer{margin:0;padding:5px 0;}.adp-admarker:hover .adp-admarker-text,.adp-admarker-hover .adp-admarker-text{display:block;white-space:nowrap;}.adp-admarker-icon{background:url('+obaIconUrl+') no-repeat top left #ccc;width:19px;height:15px;position:absolute;cursor:pointer;}div.adp-wrapper div.adp-admarker .adp-admarker-text,div.adp-wrapper div.adp-panel .adp-panel-close{background:#ccc;font-size:10px;line-height:15px;padding:0 5px;position:absolute;cursor:pointer;}body.adp-popup div.adp-wrapper div.adp-panel .adp-panel-close{position:fixed;z-index:99;}.adp-admarker-text{display:none;}.adp-top-right .adp-admarker-text,.adp-bottom-right .adp-admarker-text{right:15px;}.adp-top-left .adp-admarker-text,.adp-bottom-left .adp-admarker-text{left:15px;}.adp-panel-close{top:0;right:0;}.adp-panel-header,.adp-panel-publisherinfo{border-bottom:1px solid #ccc;}.adp-info-header,.adp-header-strong{font-weight:bold;}div.adp-wrapper div.adp-panel .adp-panel-footer{border-top:1px solid #ccc;}div.adp-wrapper div.adp-panel a:link,div.adp-wrapper div.adp-panel a:active,div.adp-wrapper div.adp-panel a:hover,div.adp-wrapper div.adp-panel a:visited{font-family:inherit;font-size:inherit;font-style:normal;font-weight:normal;color:#08C;text-decoration:underline;}div.adp-wrapper div.adp-panel a:hover{color:#005580;}';
        head.appendChild(style);
    }).apply(self);
/*!
     * mustache.js - Logic-less {{mustache}} templates with JavaScript
     * http://github.com/janl/mustache.js
     */


        (function defineMustache (global, factory) {
      if (typeof exports === 'object' && exports && typeof exports.nodeName !== 'string') {
        factory(exports); 
      } else if (typeof define === 'function' && define.amd) {
        define(['exports'], factory); 
      } else {
        global.Mustache = {};
        factory(global.Mustache); 
      }
    }(this, function mustacheFactory (mustache) {

          var objectToString = Object.prototype.toString;
      var isArray = Array.isArray || function isArrayPolyfill (object) {
        return objectToString.call(object) === '[object Array]';
      };

          function isFunction (object) {
        return typeof object === 'function';
      }

          /**
       * More correct typeof string handling array
       * which normally returns typeof 'object'
       */
      function typeStr (obj) {
        return isArray(obj) ? 'array' : typeof obj;
      }

          function escapeRegExp (string) {
        return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
      }

          /**
       * Null safe way of checking whether or not an object,
       * including its prototype, has a given property
       */
      function hasProperty (obj, propName) {
        return obj != null && typeof obj === 'object' && (propName in obj);
      }

          /**
       * Safe way of detecting whether or not the given thing is a primitive and
       * whether it has the given property
       */
      function primitiveHasOwnProperty (primitive, propName) {  
        return (
          primitive != null
          && typeof primitive !== 'object'
          && primitive.hasOwnProperty
          && primitive.hasOwnProperty(propName)
        );
      }

      var regExpTest = RegExp.prototype.test;
      function testRegExp (re, string) {
        return regExpTest.call(re, string);
      }

          var nonSpaceRe = /\S/;
      function isWhitespace (string) {
        return !testRegExp(nonSpaceRe, string);
      }

          var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
      };

          function escapeHtml (string) {
        return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap (s) {
          return entityMap[s];
        });
      }

          var whiteRe = /\s*/;
      var spaceRe = /\s+/;
      var equalsRe = /\s*=/;
      var curlyRe = /\s*\}/;
      var tagRe = /#|\^|\/|>|\{|&|=|!/;

          /**
       * Breaks up the given `template` string into a tree of tokens. If the `tags`
       * argument is given here it must be an array with two string values: the
       * opening and closing tags used in the template (e.g. [ "" ]). Of
       * course, the default is to use mustaches (i.e. mustache.tags).
       *
       * A token is an array with at least 4 elements. The first element is the
       * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
       * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
       * all text that appears outside a symbol this element is "text".
       *
       * The second element of a token is its "value". For mustache tags this is
       * whatever else was inside the tag besides the opening symbol. For text tokens
       * this is the text itself.
       *
       * The third and fourth elements of the token are the start and end indices,
       * respectively, of the token in the original template.
       *
       * Tokens that are the root node of a subtree contain two more elements: 1) an
       * array of tokens in the subtree and 2) the index in the original template at
       * which the closing tag for that section begins.
       */
      function parseTemplate (template, tags) {
        if (!template)
          return [];

            var sections = [];     
        var tokens = [];       
        var spaces = [];       
        var hasTag = false;    
        var nonSpace = false;  

        function stripSpace () {
          if (hasTag && !nonSpace) {
            while (spaces.length)
              delete tokens[spaces.pop()];
          } else {
            spaces = [];
          }

              hasTag = false;
          nonSpace = false;
        }

            var openingTagRe, closingTagRe, closingCurlyRe;
        function compileTags (tagsToCompile) {
          if (typeof tagsToCompile === 'string')
            tagsToCompile = tagsToCompile.split(spaceRe, 2);

              if (!isArray(tagsToCompile) || tagsToCompile.length !== 2)
            throw new Error('Invalid tags: ' + tagsToCompile);

              openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
          closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
          closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
        }

            compileTags(tags || mustache.tags);

            var scanner = new Scanner(template);

            var start, type, value, chr, token, openSection;
        while (!scanner.eos()) {
          start = scanner.pos;

          value = scanner.scanUntil(openingTagRe);

              if (value) {
            for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
              chr = value.charAt(i);

                  if (isWhitespace(chr)) {
                spaces.push(tokens.length);
              } else {
                nonSpace = true;
              }

                  tokens.push([ 'text', chr, start, start + 1 ]);
              start += 1;

              if (chr === '\n')
                stripSpace();
            }
          }

          if (!scanner.scan(openingTagRe))
            break;

              hasTag = true;

          type = scanner.scan(tagRe) || 'name';
          scanner.scan(whiteRe);

          if (type === '=') {
            value = scanner.scanUntil(equalsRe);
            scanner.scan(equalsRe);
            scanner.scanUntil(closingTagRe);
          } else if (type === '{') {
            value = scanner.scanUntil(closingCurlyRe);
            scanner.scan(curlyRe);
            scanner.scanUntil(closingTagRe);
            type = '&';
          } else {
            value = scanner.scanUntil(closingTagRe);
          }

          if (!scanner.scan(closingTagRe))
            throw new Error('Unclosed tag at ' + scanner.pos);

              token = [ type, value, start, scanner.pos ];
          tokens.push(token);

              if (type === '#' || type === '^') {
            sections.push(token);
          } else if (type === '/') {
            openSection = sections.pop();

                if (!openSection)
              throw new Error('Unopened section "' + value + '" at ' + start);

                if (openSection[1] !== value)
              throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
          } else if (type === 'name' || type === '{' || type === '&') {
            nonSpace = true;
          } else if (type === '=') {
            compileTags(value);
          }
        }

        openSection = sections.pop();

            if (openSection)
          throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);

            return nestTokens(squashTokens(tokens));
      }

          /**
       * Combines the values of consecutive text tokens in the given `tokens` array
       * to a single token.
       */
      function squashTokens (tokens) {
        var squashedTokens = [];

            var token, lastToken;
        for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
          token = tokens[i];

              if (token) {
            if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
              lastToken[1] += token[1];
              lastToken[3] = token[3];
            } else {
              squashedTokens.push(token);
              lastToken = token;
            }
          }
        }

            return squashedTokens;
      }

          /**
       * Forms the given array of `tokens` into a nested tree structure where
       * tokens that represent a section have two additional items: 1) an array of
       * all tokens that appear in that section and 2) the index in the original
       * template that represents the end of that section.
       */
      function nestTokens (tokens) {
        var nestedTokens = [];
        var collector = nestedTokens;
        var sections = [];

            var token, section;
        for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
          token = tokens[i];

              switch (token[0]) {
            case '#':
            case '^':
              collector.push(token);
              sections.push(token);
              collector = token[4] = [];
              break;
            case '/':
              section = sections.pop();
              section[5] = token[2];
              collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
              break;
            default:
              collector.push(token);
          }
        }

            return nestedTokens;
      }

          /**
       * A simple string scanner that is used by the template parser to find
       * tokens in template strings.
       */
      function Scanner (string) {
        this.string = string;
        this.tail = string;
        this.pos = 0;
      }

          /**
       * Returns `true` if the tail is empty (end of string).
       */
      Scanner.prototype.eos = function eos () {
        return this.tail === '';
      };

          /**
       * Tries to match the given regular expression at the current position.
       * Returns the matched text if it can match, the empty string otherwise.
       */
      Scanner.prototype.scan = function scan (re) {
        var match = this.tail.match(re);

            if (!match || match.index !== 0)
          return '';

            var string = match[0];

            this.tail = this.tail.substring(string.length);
        this.pos += string.length;

            return string;
      };

          /**
       * Skips all text until the given regular expression can be matched. Returns
       * the skipped string, which is the entire tail if no match can be made.
       */
      Scanner.prototype.scanUntil = function scanUntil (re) {
        var index = this.tail.search(re), match;

            switch (index) {
          case -1:
            match = this.tail;
            this.tail = '';
            break;
          case 0:
            match = '';
            break;
          default:
            match = this.tail.substring(0, index);
            this.tail = this.tail.substring(index);
        }

            this.pos += match.length;

            return match;
      };

          /**
       * Represents a rendering context by wrapping a view object and
       * maintaining a reference to the parent context.
       */
      function Context (view, parentContext) {
        this.view = view;
        this.cache = { '.': this.view };
        this.parent = parentContext;
      }

          /**
       * Creates a new context using the given view with this context
       * as the parent.
       */
      Context.prototype.push = function push (view) {
        return new Context(view, this);
      };

          /**
       * Returns the value of the given name in this context, traversing
       * up the context hierarchy if the value is absent in this context's view.
       */
      Context.prototype.lookup = function lookup (name) {
        var cache = this.cache;

            var value;
        if (cache.hasOwnProperty(name)) {
          value = cache[name];
        } else {
          var context = this, intermediateValue, names, index, lookupHit = false;

              while (context) {
            if (name.indexOf('.') > 0) {
              intermediateValue = context.view;
              names = name.split('.');
              index = 0;

                  /**
               * Using the dot notion path in `name`, we descend through the
               * nested objects.
               *
               * To be certain that the lookup has been successful, we have to
               * check if the last object in the path actually has the property
               * we are looking for. We store the result in `lookupHit`.
               *
               * This is specially necessary for when the value has been set to
               * `undefined` and we want to avoid looking up parent contexts.
               *
               * In the case where dot notation is used, we consider the lookup
               * to be successful even if the last "object" in the path is
               * not actually an object but a primitive (e.g., a string, or an
               * integer), because it is sometimes useful to access a property
               * of an autoboxed primitive, such as the length of a string.
               **/
              while (intermediateValue != null && index < names.length) {
                if (index === names.length - 1)
                  lookupHit = (
                    hasProperty(intermediateValue, names[index]) 
                    || primitiveHasOwnProperty(intermediateValue, names[index])
                  );

                    intermediateValue = intermediateValue[names[index++]];
              }
            } else {
              intermediateValue = context.view[name];

                  /**
               * Only checking against `hasProperty`, which always returns `false` if
               * `context.view` is not an object. Deliberately omitting the check
               * against `primitiveHasOwnProperty` if dot notation is not used.
               *
               * Consider this example:
               * ```
               * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
               * ```
               *
               * If we were to check also against `primitiveHasOwnProperty`, as we do
               * in the dot notation case, then render call would return:
               *
               * "The length of a football field is 9."
               *
               * rather than the expected:
               *
               * "The length of a football field is 100 yards."
               **/
              lookupHit = hasProperty(context.view, name);
            }

                if (lookupHit) {
              value = intermediateValue;
              break;
            }

                context = context.parent;
          }

              cache[name] = value;
        }

            if (isFunction(value))
          value = value.call(this.view);

            return value;
      };

          /**
       * A Writer knows how to take a stream of tokens and render them to a
       * string, given a context. It also maintains a cache of templates to
       * avoid the need to parse the same template twice.
       */
      function Writer () {
        this.cache = {};
      }

          /**
       * Clears all cached templates in this writer.
       */
      Writer.prototype.clearCache = function clearCache () {
        this.cache = {};
      };

          /**
       * Parses and caches the given `template` according to the given `tags` or
       * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
       * that is generated from the parse.
       */
      Writer.prototype.parse = function parse (template, tags) {
        var cache = this.cache;
        var cacheKey = template + ':' + (tags || mustache.tags).join(':');
        var tokens = cache[cacheKey];

            if (tokens == null)
          tokens = cache[cacheKey] = parseTemplate(template, tags);

            return tokens;
      };

          /**
       * High-level method that is used to render the given `template` with
       * the given `view`.
       *
       * The optional `partials` argument may be an object that contains the
       * names and templates of partials that are used in the template. It may
       * also be a function that is used to load partial templates on the fly
       * that takes a single argument: the name of the partial.
       *
       * If the optional `tags` argument is given here it must be an array with two
       * string values: the opening and closing tags used in the template (e.g.
       * [ "" ]). The default is to mustache.tags.
       */
      Writer.prototype.render = function render (template, view, partials, tags) {
        var tokens = this.parse(template, tags);
        var context = (view instanceof Context) ? view : new Context(view);
        return this.renderTokens(tokens, context, partials, template, tags);
      };

          /**
       * Low-level method that renders the given array of `tokens` using
       * the given `context` and `partials`.
       *
       * Note: The `originalTemplate` is only ever used to extract the portion
       * of the original template that was contained in a higher-order section.
       * If the template doesn't use higher-order sections, this argument may
       * be omitted.
       */
      Writer.prototype.renderTokens = function renderTokens (tokens, context, partials, originalTemplate, tags) {
        var buffer = '';

            var token, symbol, value;
        for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
          value = undefined;
          token = tokens[i];
          symbol = token[0];

              if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate);
          else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate);
          else if (symbol === '>') value = this.renderPartial(token, context, partials, tags);
          else if (symbol === '&') value = this.unescapedValue(token, context);
          else if (symbol === 'name') value = this.escapedValue(token, context);
          else if (symbol === 'text') value = this.rawValue(token);

              if (value !== undefined)
            buffer += value;
        }

            return buffer;
      };

          Writer.prototype.renderSection = function renderSection (token, context, partials, originalTemplate) {
        var self = this;
        var buffer = '';
        var value = context.lookup(token[1]);

        function subRender (template) {
          return self.render(template, context, partials);
        }

            if (!value) return;

            if (isArray(value)) {
          for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
            buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate);
          }
        } else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') {
          buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate);
        } else if (isFunction(value)) {
          if (typeof originalTemplate !== 'string')
            throw new Error('Cannot use higher-order sections without the original template');

          value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);

              if (value != null)
            buffer += value;
        } else {
          buffer += this.renderTokens(token[4], context, partials, originalTemplate);
        }
        return buffer;
      };

          Writer.prototype.renderInverted = function renderInverted (token, context, partials, originalTemplate) {
        var value = context.lookup(token[1]);

        if (!value || (isArray(value) && value.length === 0))
          return this.renderTokens(token[4], context, partials, originalTemplate);
      };

          Writer.prototype.renderPartial = function renderPartial (token, context, partials, tags) {
        if (!partials) return;

            var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null)
          return this.renderTokens(this.parse(value, tags), context, partials, value);
      };

          Writer.prototype.unescapedValue = function unescapedValue (token, context) {
        var value = context.lookup(token[1]);
        if (value != null)
          return value;
      };

          Writer.prototype.escapedValue = function escapedValue (token, context) {
        var value = context.lookup(token[1]);
        if (value != null)
          return mustache.escape(value);
      };

          Writer.prototype.rawValue = function rawValue (token) {
        return token[1];
      };

          mustache.name = 'mustache.js';
      mustache.version = '3.0.1';
      mustache.tags = [ '{{', '}}' ];

      var defaultWriter = new Writer();

          /**
       * Clears all cached templates in the default writer.
       */
      mustache.clearCache = function clearCache () {
        return defaultWriter.clearCache();
      };

          /**
       * Parses and caches the given template in the default writer and returns the
       * array of tokens it contains. Doing this ahead of time avoids the need to
       * parse templates on the fly as they are rendered.
       */
      mustache.parse = function parse (template, tags) {
        return defaultWriter.parse(template, tags);
      };

          /**
       * Renders the `template` with the given `view` and `partials` using the
       * default writer. If the optional `tags` argument is given here it must be an
       * array with two string values: the opening and closing tags used in the
       * template (e.g. [ "" ]). The default is to mustache.tags.
       */
      mustache.render = function render (template, view, partials, tags) {
        if (typeof template !== 'string') {
          throw new TypeError('Invalid template! Template should be a "string" ' +
                              'but "' + typeStr(template) + '" was given as the first ' +
                              'argument for mustache#render(template, view, partials)');
        }

            return defaultWriter.render(template, view, partials, tags);
      };

      mustache.to_html = function to_html (template, view, partials, send) {

            var result = mustache.render(template, view, partials);

            if (isFunction(send)) {
          send(result);
        } else {
          return result;
        }
      };

      mustache.escape = escapeHtml;

      mustache.Scanner = Scanner;
      mustache.Context = Context;
      mustache.Writer = Writer;

          return mustache;
    }));

    (function() {
        var ApiList = new self.ObjectList(),
            BidderList = new self.ObjectList(),
            BidderApiObjects = {},
        _;

                self.Auction = {};

        self.Auction.Api = function(id, config, params) {
            if (this === self.Auction) {
                return id instanceof self.Auction.Api ? id : (ApiList.get(id) || new self.Auction.Api(id, config, params));
            }
            this.id = id;
            this.config = config;
            this.params = params;
            this.auctionResult = {};

                        self.Auction.Bidder.setApiObject(this.id, this);

            this.defaultScriptUrl = '#';

            this.startEvent = 'body.begin';

            this.isLoaded = function() {
                return false;
            };

            this.initialize = function() {
            };

                        this.startProcess = function(callback) {
                self.log.nyi('AdService.Auction.Api(\''+this.id+'\').startProcess()');
                callback({});
            };

                        this.getSlotResult = function(slot) {
                var result = this.auctionResult[slot] || {bidder:'_none'};
                return self.Auction.Bidder(result.bidder, result);
            };

                        this.recurseSlots = function(slots, codePrefix, callback) {
                var object = this;
                each(slots, function(name, value) {
                    if (name.indexOf('_') === 0) { return; }
                    if (!value._sizes) {
                        return object.recurseSlots(value, codePrefix + name + '|', callback);
                    }
                    each(value, function(bidder, config) {
                        if (bidder.indexOf('_') === 0) { return; }
                        callback(codePrefix + name, bidder, config, value);
                    });
                });
            };

                        ApiList.register(this);
        };
        self.Auction.Api.getList = function() {
            return ApiList.getList();
        };

        function setApiObject(bObj, api, obj) {
            bObj['Api_' + api] = extend({}, obj);
        }
        self.Auction.Bidder = function(id, config, params) {
            if (this === self.Auction) {
                return id instanceof self.Auction.Bidder ? id : (BidderList.get(id) || new self.Auction.Bidder(id, config, params));
            }
            this.id = id;
            this.config = config;
            this.params = params;
            var bidder = this;
            each(BidderApiObjects, function(api, obj) {
                setApiObject(bidder, api, obj);
            });

                        this.getAdContent = function() {
            }

                        BidderList.register(this);
        };
        self.Auction.Bidder.setApiObject = function(api, obj) {
            BidderApiObjects[api] = obj;
            each(BidderList.getList(), function(bidder, bObj) {
                setApiObject(bObj, api, obj);
            });
        };
        self.Auction.Bidder.getList = function() {
            return BidderList.getList();
        };
    }).apply(self);
    (function() {
        var api = new self.Auction.Api('prebid', {
        }, {
        });

            if (window.location.hostname.split('.')[0] === 'qa') {
            api.defaultScriptUrl = 'https://dl-preview.web.de/uim/container/prebid_dev.js';
        } else {
            api.defaultScriptUrl = '//dl.web.de/uim/container/prebid_21.js';
        }
        api.startEvent = 'body.begin';

            api.isLoaded = function() {
            return !!win.pbjs;
        };

            var tcfVersion = 1;
        if (win.__tcfapi) {
            win.__tcfapi('getTCFVersion', 2, function(response) { tcfVersion = parseInt(response); });
        }
        var tcf1 = "BO4Jl22O4Jl22CnABBDEDX-AAAAyh7_______9_-____9uz_Ov_v_f__33e8__9v_l_7_-___u_-23d4u_1vf99ycmx-5etr3tp_47ues2_Xurf_71__3z3_9pxP78E89r5335EQ_v-_t-b7BCHN_Y2v-8K96lPKACEI";
        api.initialize = function() {
            pbjs.setConfig({
                "consentManagement": tcfVersion === 2 ? {
                    "gdpr": {
                        "cmpApi": "iab",
                        "timeout": 9000,
                        "defaultGdprScope": true
                    }
                } : {
                    "gdpr": {
                        "cmpApi": "static",
                        "allowAuctionWithoutConsent": false,
                        "consentData": {"getConsentData":{"gdprApplies":true,"hasGlobalScope":false,"consentData":tcf1},"getVendorConsents":{"metadata":tcf1,"gdprApplies":true,"hasGlobalScope":false,"cookieVersion":1,"created":"2020-08-14T21:59:59.000Z","lastUpdated":"2020-08-14T21:59:59.000Z","cmpId":167,"cmpVersion":1,"consentScreen":1,"consentLanguage":"de","vendorListVersion":215,"maxVendorId":808,"isRange":false,"purposeConsents":{"1":true,"2":true,"3":true,"4":true,"6":true,"7":true,"8":true,"9":true,"10":true,"11":true,"12":true,"13":true,"14":true,"15":true,"16":true,"17":true,"18":true,"19":true,"20":true,"21":true,"22":true,"23":true,"24":true,"25":true,"26":true,"27":true,"28":true,"29":true,"30":true,"31":true,"32":true,"33":true,"34":true,"35":true,"36":true,"37":true,"38":true,"39":true,"40":true,"41":true,"42":true,"43":true,"44":true,"45":true,"46":true,"47":true,"48":true,"49":true,"50":true,"51":true,"52":true,"53":true,"55":true,"56":true,"57":true,"58":true,"59":true,"60":true,"61":true,"62":true,"63":true,"64":true,"65":true,"66":true,"68":true,"69":true,"70":true,"71":true,"72":true,"73":true,"74":true,"75":true,"76":true,"77":true,"78":true,"79":true,"80":true,"81":true,"82":true,"83":true,"84":true,"85":true,"86":true,"87":true,"88":true,"89":true,"90":true,"91":true,"92":true,"93":true,"94":true,"95":true,"97":true,"98":true,"100":true,"101":true,"102":true,"104":true,"105":true,"108":true,"109":true,"110":true,"111":true,"112":true,"113":true,"114":true,"115":true,"118":true,"119":true,"120":true,"122":true,"124":true,"125":true,"126":true,"127":true,"128":true,"129":true,"130":true,"131":true,"132":true,"133":true,"134":true,"136":true,"137":true,"138":true,"139":true,"140":true,"141":true,"142":true,"143":true,"144":true,"145":true,"147":true,"148":true,"149":true,"150":true,"151":true,"152":true,"153":true,"154":true,"155":true,"156":true,"157":true,"158":true,"159":true,"160":true,"161":true,"162":true,"163":true,"164":true,"165":true,"167":true,"168":true,"169":true,"170":true,"171":true,"173":true,"174":true,"175":true,"177":true,"178":true,"179":true,"180":true,"182":true,"183":true,"184":true,"185":true,"188":true,"189":true,"190":true,"191":true,"192":true,"193":true,"194":true,"195":true,"196":true,"197":true,"198":true,"199":true,"200":true,"201":true,"202":true,"203":true,"205":true,"206":true,"208":true,"209":true,"210":true,"211":true,"212":true,"213":true,"214":true,"215":true,"216":true,"217":true,"218":true,"221":true,"223":true,"224":true,"225":true,"226":true,"227":true,"228":true,"229":true,"230":true,"231":true,"232":true,"234":true,"235":true,"236":true,"237":true,"238":true,"239":true,"240":true,"241":true,"242":true,"243":true,"244":true,"245":true,"246":true,"248":true,"249":true,"250":true,"251":true,"252":true,"253":true,"254":true,"255":true,"256":true,"257":true,"258":true,"259":true,"260":true,"261":true,"262":true,"263":true,"264":true,"265":true,"266":true,"268":true,"269":true,"270":true,"272":true,"273":true,"274":true,"275":true,"276":true,"277":true,"278":true,"279":true,"280":true,"281":true,"282":true,"284":true,"285":true,"287":true,"288":true,"290":true,"291":true,"293":true,"294":true,"295":true,"297":true,"298":true,"299":true,"301":true,"302":true,"303":true,"304":true,"308":true,"310":true,"311":true,"312":true,"314":true,"315":true,"316":true,"317":true,"318":true,"319":true,"320":true,"321":true,"323":true,"325":true,"326":true,"328":true,"329":true,"330":true,"331":true,"333":true,"334":true,"335":true,"336":true,"337":true,"338":true,"339":true,"340":true,"341":true,"343":true,"344":true,"345":true,"346":true,"347":true,"349":true,"350":true,"351":true,"354":true,"357":true,"358":true,"359":true,"362":true,"365":true,"366":true,"368":true,"369":true,"373":true,"374":true,"375":true,"376":true,"377":true,"378":true,"380":true,"381":true,"382":true,"385":true,"387":true,"388":true,"389":true,"390":true,"392":true,"394":true,"395":true,"397":true,"398":true,"400":true,"402":true,"403":true,"404":true,"405":true,"407":true,"408":true,"409":true,"410":true,"412":true,"413":true,"415":true,"416":true,"418":true,"421":true,"422":true,"423":true,"424":true,"425":true,"426":true,"427":true,"428":true,"429":true,"430":true,"434":true,"435":true,"436":true,"438":true,"439":true,"440":true,"442":true,"443":true,"444":true,"447":true,"448":true,"449":true,"450":true,"452":true,"454":true,"455":true,"458":true,"459":true,"461":true,"462":true,"464":true,"465":true,"466":true,"467":true,"468":true,"469":true,"471":true,"473":true,"474":true,"475":true,"476":true,"478":true,"479":true,"480":true,"482":true,"484":true,"486":true,"487":true,"489":true,"490":true,"491":true,"492":true,"493":true,"494":true,"495":true,"496":true,"497":true,"498":true,"499":true,"500":true,"501":true,"502":true,"504":true,"505":true,"506":true,"507":true,"509":true,"511":true,"512":true,"513":true,"514":true,"515":true,"516":true,"517":true,"518":true,"519":true,"520":true,"521":true,"522":true,"523":true,"524":true,"525":true,"527":true,"528":true,"529":true,"530":true,"531":true,"534":true,"535":true,"536":true,"537":true,"539":true,"540":true,"541":true,"542":true,"543":true,"544":true,"545":true,"546":true,"547":true,"548":true,"549":true,"550":true,"551":true,"553":true,"554":true,"556":true,"559":true,"560":true,"561":true,"565":true,"568":true,"569":true,"570":true,"571":true,"572":true,"573":true,"574":true,"576":true,"577":true,"578":true,"579":true,"580":true,"581":true,"587":true,"590":true,"591":true,"592":true,"593":true,"596":true,"597":true,"598":true,"599":true,"601":true,"602":true,"604":true,"606":true,"607":true,"608":true,"609":true,"610":true,"613":true,"614":true,"615":true,"617":true,"618":true,"619":true,"620":true,"621":true,"623":true,"624":true,"625":true,"626":true,"627":true,"628":true,"631":true,"635":true,"639":true,"644":true,"645":true,"646":true,"647":true,"648":true,"649":true,"650":true,"652":true,"653":true,"654":true,"655":true,"656":true,"657":true,"658":true,"659":true,"660":true,"662":true,"663":true,"664":true,"665":true,"666":true,"667":true,"668":true,"670":true,"671":true,"673":true,"674":true,"675":true,"676":true,"677":true,"678":true,"681":true,"682":true,"684":true,"685":true,"686":true,"687":true,"688":true,"690":true,"691":true,"697":true,"702":true,"707":true,"708":true,"709":true,"712":true,"713":true,"715":true,"716":true,"717":true,"718":true,"719":true,"720":true,"721":true,"723":true,"724":true,"728":true,"729":true,"731":true,"732":true,"734":true,"736":true,"737":true,"738":true,"739":true,"740":true,"741":true,"742":true,"743":true,"744":true,"746":true,"747":true,"748":true,"749":true,"754":true,"756":true,"758":true,"759":true,"760":true,"761":true,"763":true,"764":true,"765":true,"766":true,"768":true,"770":true,"773":true,"775":true,"778":true,"779":true,"780":true,"781":true,"784":true,"786":true,"798":true,"803":true,"808":true}}}
                    }
                },
                "priceGranularity": "high",
                "cache": {
                    "url": "https://prebid.adnxs.com/pbc/v1/cache"
                },
                "bidderSequence": "random",
                "enableSendAllBids": true,
                "userSync": {
                    "filterSettings":{"all":{"bidders":["unifiedId", "criteo"],"filter":"include"}},
                    "userIds":[{
                        "name":"unifiedId",
                        "params":{"url":"//match.adsrvr.org/track/rid?ttd_pid=51kb8ap&fmt=json"},
                        "storage":{"type":"html5","name":"prebid_id_unified","expires":365}
                    },
                    {"name":"criteo"}]
                }
            });
            var iabchaindomain = {'webde':['de','web'], 'gmx':['net','gmx'], 'gmxat':['at','gmx'], 'gmxch':['ch','gmx']}[AdService.getParam('portal')] || ['de','web'],
                iabcallbackQueue = [],
                iabloaded = false;
            var iabchain = doc.createElement('script');
            iabchain.src = 'https://dl.' + iabchaindomain[1] + '.' + iabchaindomain[0] + '/uim/bidding/consent.js';
            iabchain.addEventListener('load', function(evt) {
                iabloaded = true;
                for (var i=0, l=iabcallbackQueue.length; i<l; i++) {
                    try {
                        iabcallbackQueue[i]();
                    } catch (e) {
                        AdService.log.error('Error in IAB callback function', e, this);
                    }
                }
            }, false);
            doc.getElementsByTagName('head')[0].appendChild(iabchain);
            win.__cmp = function(action, version, callback) {
                var optoutswitcher = (AdService.getParam('optout') !== '1' && /^(2|3)$/.test(AdService.getParam('consentlevel'))) ? 'optin' : 'optout';
                function returnchain(action, version, callback) {
                    var consent = (typeof window.UI_iabchain !== 'undefined' ? UI_iabchain[optoutswitcher] : null) || {consent:{}, vendor:{}};
                    if (action === 'getConsentData') {
                        callback(consent.consent);
                    } else if (action === 'getVendorConsents') {
                        callback(consent.vendor);
                    } else if (action === 'ping') {
                        callback({gdprAppliesGlobally:false, cmpLoaded:typeof iabloaded !== 'undefined' && iabloaded === true});
                    }
                }
                if (iabloaded) {
                    returnchain(action, version, callback);
                } else {
                    iabcallbackQueue.push(function() { returnchain(action, version, callback); });
                }
            };
        };

            function prepareSizes(org) {
            var sizes = [];
            each(org, function(i, size) {
                sizes.push(size.split('x').map(function(x) { return +x; }));
            });
            return sizes;
        }

            api.startProcess = function(callback) {
            self.trigger('auction.startProcess');
            var adUnits = {};
            api.recurseSlots(self.getAuctionConfig().slots, '', function(slot, bidder, config, base) {
                if (!adUnits[slot]) {
                    adUnits[slot] = {
                        code: slot,
                        mediaTypes: {banner: {sizes: prepareSizes(base._sizes)}},
                        bids: []
                    };
                    if (typeof base._mediaTypes !== 'undefined') {
                        if (base._mediaTypes === null) {
                            delete adUnits[slot].mediaTypes;
                        } else {
                            adUnits[slot].mediaTypes = base._mediaTypes;
                        }
                    }
                }
                config.bidder = bidder;
                adUnits[slot].bids.push(config);
                win.pbjs.bidderSettings[bidder] = (self.Auction.Bidder(bidder).Api_prebid.getBidderSettings || function() { return {}; })();
            });
            var adUnitResult = [];
            each(adUnits, function(name, value) { adUnitResult.push(value); });
            win.pbjs.que.push(function() {
                win.pbjs.addAdUnits(adUnitResult);
                win.pbjs.requestBids({
                    bidsBackHandler: function(bidResponses) {
                        api.rawAuctionResult = bidResponses;
                        api.auctionResult = {};

                            each(win.pbjs.getHighestCpmBids(), function(i, item) {
                            var slot = item.adUnitCode.split('|')[0];
                            if (!api.auctionResult[slot] || item.cpm > api.auctionResult[slot].cpm) {
                                api.auctionResult[slot] = item;
                            }
                        });

                            self.log.level('auction', 'Auction result:', 'response', bidResponses);
                        self.log.level('auction', 'Highest bids:', win.pbjs.getHighestCpmBids());
                        self.log.level('auction', 'Resulting object:', api.auctionResult);

                            callback(api.auctionResult);
                    },
                    timeout: 6000, 
                    bidderTimeout: 5000
                });
            });
        };

            api.getSlotResult = function(slot) {
            slot = self._getAdSlot(slot);
            return api.auctionResult[slot.id] || {};
            var data = (api.auctionResult[slot.id] || {bids:[]}).bids,
                result = {cpm:-1, bidder:'_none'},
            _;
            each(data, function(i, item) {
                if (+item.cpm > +result.cpm) {
                    result = item;
                }
            });
            return self.Auction.Bidder(result.bidder, result);
        };
    }).apply(self);

    (function() {
        var bidder = new self.Auction.Bidder('appnexus');

                bidder.Api_prebid.getBidderSettings = function() {
            return {
                bidCpmAdjustment: function(bidCpm) { return bidCpm * 0.87047; }
            };
        };
    }).apply(self);
    (function() {
        var bidder = new self.Auction.Bidder('pubmatic');

                bidder.Api_prebid.getBidderSettings = function() {
            return {
                bidCpmAdjustment: function(bidCpm) { return bidCpm * 0.87047; }
            };
        };
    }).apply(self);
    (function() {
        var bidder = new self.Auction.Bidder('yieldlab');

                bidder.Api_prebid.getBidderSettings = function() {
            return {
                bidCpmAdjustment: function(bidCpm) { return bidCpm * 0.938; }
            };
        };
    }).apply(self);
    (function() {
        var config = {
            enabled: true,
            script: undefined,
            scriptapi: 'prebid',
            timeout: {bidder: 3000, total: 4000},
            disableonadblock: true,
        _:0};
        delete config._;

                var adsQueue = [];

                var inits = {
            disableonadblock: function(value, config) {
                if (!value) { return; }
                if (!config.enabled) { return; }
                var isBlocked = self.info.abd().isBlocked;
                if (isBlocked) {
                    config.enabled = false;
                }
            },
            script: function(value, config) {
                if (!config.enabled) { return; }

                self.on('ad.begin', function(evt) {
                    if (self.getQueue('auction.finished') === false) { return; }
                    evt.data.deferred = true;
                    adsQueue.push(evt);
                });

                                self.log.level('auction', 'Prebid activated, initializing');
                var api = self.Auction.Api(config.scriptapi),
                    loaded = api.isLoaded(),
                _;
                if (!loaded) {
                    self.log.level('auction', 'Starting to load script', value || api.defaultScriptUrl);

                    var mustBeInIframe = false; 
                    var isInIframe = window._isNfi; 
                    if (mustBeInIframe && !isInIframe) {
                        var passOverData = {
                            auction: true,
                            auctionapi: api.id,
                            auctionscript: value || api.defaultScriptUrl,
                            auctionconfig: config,
                            connector: self.getConfig('adservice-iframe-script-url'),
                        };
                        var html = fillIn(
                            '<iframe src="{nfiDocument}" name="{data}" data-{namespace}-auction="true" frameborder="0" border="0" scrolling="no" marginwidth="0" marginheight="0" width="1" height="1" style="position: fixed; top: -1000px; left: -1000px;"><\/iframe>',
                            {
                                namespace: self.getConfig('data-attribute-namespace'),
                                nfiDocument: Code.html(self.getConfig('nonfriendlyiframe-document') || self.getDefaultAdServer().getConfig('nonfriendlyiframe-document')),
                                data: Code.html(JSON.stringify(passOverData))
                            }
                        );
                        doc.body.insertAdjacentHTML('afterbegin', html);
                        self.log.level('auction', 'Prebid IFrame created', html);
                        return;
                    }

                                        var script = document.createElement('script');
                    script.src = value || api.defaultScriptUrl;
                    document.getElementsByTagName('head')[0].appendChild(script);
                    script.addEventListener('load', function() {
                        self.log.level('auction', 'Script loading finished');
                        self.waitingComplete('auction.scriptloaded');
                    }, false);
                    self.registerWaitingQueue('auction.scriptloaded');
                }
                self.waitFor('auction.scriptloaded', function() {
                    self.log.level('auction', 'Waiting for event "' + api.startEvent + '"');
                    api.initialize();
                    self.on(api.startEvent, function() {
                        self.log.level('auction', 'Start auction process of type', config.scriptapi);
                        api.startProcess(function(auctionData) {
                            self.log.level('auction', 'Auctions are done', auctionData);
                            self.trigger('auction.complete', auctionData);
                            self.waitingComplete('auction.finished');
                            each(adsQueue, function(index, item) {
                                self.ad(item.data.slot);
                            });
                            adsQueue = [];
                        });
                    });
                });
                self.registerWaitingQueue('auction.finished');
            },
        _:0};

                self.getAuctionConfig = function(name, defaultValue) {
            if (!name) { return config; }
            if (config.hasOwnProperty(name)) { return config[name]; }
            return defaultValue;
        };

                self.setAuctionConfig = function(obj) {
            if (typeof obj === 'function') {
                try {
                    obj = obj();
                } catch (e) {
                    return self.log.error('Error in function supplied for AdService.setAuctionConfig()', e, arguments, data, this);
                }
            }
            config = defaults(obj, config);
            each(inits, function(name, value) {
                if (typeof value !== 'function') { return; }
                value(config[name], config);
            });
            self.log.level('auction', 'Auction config set', 'New values:', obj, 'Resulting config:', config);
            return self;
        };

                self.enableAuctions = function() {
            config.enabled = true;
        };
        self.disableAuctions = function() {
            config.enabled = false;
        };
        self.auctionsIsEnabled = function() {
            return config.enabled;
        };

                self.applyAuction = function() {
            self.log.level('auction', 'AdServer selected auction result to be used', this);

                        var api = self.Auction.Api(config.scriptapi),
                slot = self._getAdSlot(this.slot),
                slotResult = api.getSlotResult(slot),
            _;

                        slotResult._specificData = arguments;

            self.Communication.sendMessage(dom('iframe', slot.getDomNode())[0], 'insertAd', slotResult);
        };

                self.adInserted = function(data) {
            self.log.level('auction', 'Ad has been inserted into IFrame', data, this);
            if (data.width != 220 || data.height != 600) {
                this.slot.resize(data.width, data.height, [this.iframe]);
            }
            self._ad_finished(this.slot, data);
        }
    }).apply(self);
    (function() {
        createSendMethod([
            'applyAuction',
            'enableAuctions', 'disableAuctions',
            'adInserted'
        ]);
        self.insertAd = function(data) {
            var metaElement = document.querySelector('uim\\:ad'),
                metaData = {cuid:'contentunitid', cid:'campaignid', bid:'bannerid', portal:'', category:'', section:'', tagid:'', width:'', height:'', adsize:'', ovkid:''},
            _;
            each(metaData, function(name, value) {
                metaData[name] = (metaElement && metaElement.getAttribute(value || name)) || '';
            });
            metaData.pos = window._adSlot;
            if (data.mediaType === 'native') {
                var obj = {
                    _type: 'teaser-hs-image',
                    _meta: metaData,
                    count: data.native.impressionTrackers,
                    clickcount: data.native.clickTrackers,
                    clickurl: data.native.clickUrl,
                    target: '_blank',
                    imageurl: data.native.image.url,
                    partner: data.native.sponsoredBy || undefined,
                    headline: data.native.title,
                    subline: data.native.body
                };
                if (data._specificData && data._specificData[0]) {
                    if (data._specificData[0]._oba) { obj._oba = data._specificData[0]._oba; }
                    if (data._specificData[0]._oba_direct) { obj._oba_direct = data._specificData[0]._oba_direct; }
                    if (data._specificData[0].clickurl) { obj.clickurl = data._specificData[0].clickurl + obj.clickurl; }
                }
                self.render(obj);
                return;
            }
            if (data.mediaType === 'video') {
                var script = document.createElement('script'),
                    targetId = 'videoslot' + (new Date().getTime()),
                    target = document.createElement('div');
                target.id = targetId;
                document.body.getElementsByTagName('div')[0].appendChild(target);
                script.src = data.adResponse.ad.renderer_url;
                script.onload = function() {
                    ANOutstreamVideo.renderAd({
                        targetId: targetId,
                        adResponse: data.adResponse,
                        rendererOptions: {adText: 'Anzeige', 'parentIframeGeometryEvent': 'parentFrameSizeChange'}
                    });
                };
                document.getElementsByTagName('head')[0].appendChild(script);
                return;
            }
            document.open();
            document.write(data.ad);
            document.close();
            self.adInserted(data);
        };
    }).apply(self);

    (function() {
        var MethodList = new self.ObjectList(),
            storage = [];

                self.Communication = new function() {
            this.handlePostMessage = function(evt) {
                var sourceIframe = this.getIframe(evt.source),
                    data = this.parsePostMessage(evt.data);
                if (!sourceIframe && evt.source !== top) {
                    return this.demandRedo(data);
                }
                this.handleMessage(data, sourceIframe.contentWindow || evt.source, evt);
            };
            this.handleMessage = function(message, source, evt) {
                var message = this.normalizeMessage(message),
                    sourceMessage = typeof message.sourceId !== 'undefined' ? storage[message.sourceId] : undefined,
                _;

                                if (message.type === Const.MESSAGE_TYPE.CALL) {
                    if (source !== win.top) {
                        var currentAdSlot = self._getCurrentAdSlot(),
                            iframe = this.getIframe(source),
                            callerSlot = self._getAdSlot(iframe.parentNode.getAttribute(self.getDataAttrName('slot'))),
                        _;
                        self._setCurrentAdSlot(callerSlot);
                        try {
                            var method = AdService['_from_iframe_'+message.name] || (MethodList.get(message.name)||{}).func || AdService[message.name],
                                result,
                                result = method.apply({
                                    isPostMessage: true,
                                    message: message,
                                    window: source,
                                    iframe: iframe,
                                    slot: callerSlot,
                                    event: evt
                                }, makeArray(message.data, true)),
                            _;
                            if (result !== null) {
                                this.answerMessage(message, source, message.name, result);
                            }
                        } catch (e) {
                            self.log.error('Communication.handleMessage', 'Error in function request', e, arguments, this);
                        }
                        self._setCurrentAdSlot(currentAdSlot);
                    } else {
                        try {
                            var method = AdService[message.name],
                                result,
                                result = method.apply({
                                    isPostMessage: true,
                                    message: message,
                                    window: source,
                                    iframe: iframe,
                                    slot: callerSlot,
                                    event: evt
                                }, makeArray(message.data, true)),
                            _;
                            if (result !== null) {
                                this.answerMessage(message, source, message.name, result);
                            }
                        } catch (e) {
                            self.log.error('Communication.handleMessage', 'Error in function request in IFrame', e, arguments, this);
                        }
                    }
                } else if (message.type === Const.MESSAGE_TYPE.DEMAND_REDO) {
                    var test = storage[message.id];
                    if (test && test.name === message.name) {
                        this.sendPostMessage(source, test);
                    }
                }

                                if (typeof sourceMessage !== 'undefined' && typeof sourceMessage.callback === 'function') {
                    try {
                        sourceMessage.callback(message.data);
                    } catch (e) {
                        self.log.error('Communication.handleMessage', 'Error in callback function', e, arguments, this);
                    }
                }
            };
            this.answerMessage = function(sourceMessage, target, name, data) {
                var message = this.createMessage('answer#'+name, data);
                if (typeof sourceMessage !== 'undefined' && typeof sourceMessage.id !== 'undefined') {
                    message.sourceId = sourceMessage.id;
                }
                this._sendMessage(target, message);
            };
            this.sendMessage = function(target, name, data, callback) {
                if (data && !callback && typeof data === 'function') {
                    callback = data;
                    data = {};
                }
                var message = this.createMessage(name, data, callback);
                this._sendMessage(target, message);
            };
            this._sendMessage = function(target, message) {
                this.createMessageId(message);
                if (target.window === target) {
                    this.sendPostMessage(target, message);
                } else if (target.nodeName && target.nodeName.toLowerCase() === 'iframe') {
                    this.sendPostMessage(target.contentWindow, message);
                } else if (target instanceof HTMLElement) {
                    this.sendDirectMessage(target, message);
                }
            };
            this.sendPostMessage = function(targetWindow, message) {
                message = typeof message === 'string' ? message : JSON.stringify(message);
                (new win.Function('targetWindow', 'message', "targetWindow.postMessage(message, '*');"))(targetWindow, message);

            };
            this.sendDirectMessage = function(target, message) {
                var evt = new CustomEvent(message.name, message);
                target.dispatchEvent(evt);
            };

            this.addMethod = function(name, func) {
                MethodList.register({
                    id: name,
                    func: func,
                _:0});
                return this;
            };
            this.demandRedo = function(sourceMessage) {
                return;
            };

            this.getIframe = function(windowObject) {
                if (!windowObject) { return false; }
                var iframes = doc.getElementsByTagName('iframe');
                for (var i=0, l=iframes.length; i<l; i++) {
                    if (iframes[i].contentWindow === windowObject) {
                        return iframes[i];
                    }
                }
                return false;
            };
            this.parsePostMessage = function(message) {
                try {
                    return JSON.parse(message);
                } catch (e) {
                }
                return message;
            };
            this.normalizeMessage = function(message) {
                if (typeof message === 'string') {
                    message = {name: message};
                };
                return message;
            };
            this.createMessage = function(name, data, callback) {
                var type = Const.MESSAGE_TYPE.CALL;
                if (name.indexOf('answer#') === 0) {
                    type = Const.MESSAGE_TYPE.ANSWER;
                    name = name.substr('answer#'.length);
                } else if (name.indexOf('demandredo#') === 0) {
                    type = Const.MESSAGE_TYPE.DEMAND_REDO;
                    name = name.substr('demandredo#'.length);
                }
                var message = {
                    type: type,
                    name: name,
                    data: data,
                    callback: callback
                };
                return message;
            };
            this.createMessageId = function(message) {
                message.id = storage.push(message) - 1;
            };

            this.init = function() {

                    win.addEventListener('message', function(evt) {
                    self.Communication.handlePostMessage(evt);
                });
            };
            this.init();
        };


                self.sendMessage = function() {
            self.Communication.sendMessage.apply(self.Communication, arguments);
        }
    }).apply(self);
    (function() {
        self.Communication.addMethod('resolution', function(message, source, evt) {
            var info = self.info.view();
            return info.screen;
        });
        self.Communication.addMethod('windowSize', function(message, source, evt) {
            var info = self.info.view();
            return info.viewport;
        });
        self.Communication.addMethod('hasCanvas', function(message, source, evt) {
            var info = self.info.features();
            return info.canvas;
        });
        self.Communication.addMethod('os', function(message, source, evt) {
            var info = self.info.ua();
            return info.os.name;
        });
        self.Communication.addMethod('browser', function(message, source, evt) {
            var info = self.info.ua();
            return info.browser.name;
        });
        self.Communication.addMethod('browserVersion', function(message, source, evt) {
            var info = self.info.ua();
            return info.browser.version.majorminor;
        });
        self.Communication.addMethod('adOffset', function(message, source, evt) {
            var info = source.getBoundingClientRect();
            return {x:info.left, y:info.top};
        });
        self.Communication.addMethod('scrollPosition', function(message, source, evt) {
            var info = doc.body.scrollTop;
            return info;
        });
        self.Communication.addMethod('pageHeight', function(message, source, evt) {
            var info = doc.body.offsetHeight;
            return info;
        });
    }).apply(self);

    function createSendMethod(method) {
        if (typeof method === 'string') { method = [method]; }
        if (method instanceof Array) {
            each(method, function(i, name) {
                self[name] = (function(name) { return function() {
                    var callback = (typeof arguments[arguments.length-1] === 'function') ? arguments[arguments.length-1] : function() { };
                    self.sendMessage(top, name, arguments, function(data) {
                        self.trigger('answer.'+name, data);
                        callback(data);
                    });
                }; })(name).bind(self);
            });
        } else {
            each(method, function(name, config) {
                var method = config.method || name;
                self[name] = (function(name, method) { return config.timeout
                    ? function() {
                          var args = arguments;
                          var callback = (typeof arguments[arguments.length-1] === 'function') ? arguments[arguments.length-1] : function() { };
                          window.setTimeout(function() {
                              self.sendMessage(top, method, args, function(data) {
                                  self.trigger('answer.'+method, data);
                                  callback(data);
                              })
                          }, config.timeout);
                      }
                    : function() {
                          var callback = (typeof arguments[arguments.length-1] === 'function') ? arguments[arguments.length-1] : function() { };
                          self.sendMessage(top, method, arguments, function(data) {
                              self.trigger('answer.'+method, data);
                              callback(data);
                          })
                    ;
                }; })(name, method).bind(self);
            });
        }
    }
    self.Connector = new function() {
        this.createSendMethod = createSendMethod;
    };
    (function() {
        createSendMethod([
            'triggerUp'
        ]);
    }).apply(self);
    (function() {
        createSendMethod([
            'setDefaultAdServer',
            'enableServer', 'disableServer',
            'getParam', 'getConfig', 'getDeviceClass',
            'setParam', 'setConfig'
        ]);
        self.getDefaultAdServer = function() {
            return self.AdServer(window._adServer);
        };
    }).apply(self);
    (function() {
        createSendMethod([
            'createAd', 'setAdProperty',
            'expandAd', 'contractAd', 
            'closeAd', 
            'openLayer', 'closeLayer',
        ]);
        self.on('answer.createAd', function(evt) {
        });
    }).apply(self);
    (function() {
        createSendMethod([
            'disableSlot', 'enableSlot', 'disableAllSlots', 'enableAllSlots',
            'getSlotParam', 'setSlotParam',
            'emptySlot', 'killSlot', 'hideSlot', 'showSlot',
            'createSlot', '_getAdSlot'
        ]);
        self._getCurrentAdSlot = function(){
            return win._adSlot;
        };
        self._setCurrentAdSlot = function(slot){
            win._adSlot = slot;
        }
    }).apply(self);
    (function() {
        createSendMethod([
            'cleanup',
            'disableRefresh', 'enableRefresh', 'refresh',
            'getAdUrl',
            'setAdSize'
        ]);
    }).apply(self);
    (function() {
        createSendMethod([
        ]);
        self.useIframeCss = function(data) {
            if (window._cssSet) { return; }
            document.getElementById('pageStyles').innerText = data.css;
            self.triggerUp('ad.useiframecss.done', window._adSlot, data);
            window._cssSet = true;
        };
    }).apply(self);
    (function() {
        createSendMethod([
            'render'
        ]);
        self.on('answer.render', function(evt) {
            top.console.warn('answer.render', evt);
            var ints = [100, 1000, 2500];
            for (var i=0, l=ints.length; i<l; i++) {
                win.setTimeout(function() { checkAdReady(); }, ints[i]);
            }
            var container = document.createElement('div');
            container.innerHTML = evt.data;
            dom('#external-script')[0].parentNode.appendChild(container);
        });
    }).apply(self);
    (function() {
        self.param = function(obj, sepParam, sepValue, escFuncName, escFuncValue) { 
            var param = [];
            each(obj, function(name, value) {
                param.push((escFuncName||Code.url)(''+name) + (sepValue||'=') + (escFuncValue||escFuncName||Code.url)(''+value));
            });
            return param.join(sepParam||'&');
        };

                self.createHtmlFromDom = function(domNode) {
            var el = document.createElement('div');
            el.appendChild(domNode);
            return el.innerHTML;
        };
        self.createSlotHtml = function(slot, attr, adServiceData) {
            return self.createHtmlFromDom(self.createSlotDomNode.apply(self, arguments));
        };
        self.createSlotDomNode = function(slot, attr, adServiceData) {
            var el = document.createElement('div');
            el.setAttribute(self.getDataAttrName('slot'), slot);
            attr && each(attr, function(name, value) {
                el.setAttribute(name, value);
            });
            adServiceData && each(adServiceData, function(name, value) {
                el.setAttribute(self.getDataAttrName(name), value);
            });
            return el;
        };
        self.loadJsonp = function(url) {
            var head = document.getElementsByTagName('head')[0],
                script = document.createElement('script'),
            _;
            script.src = url;
            head.appendChild(script);
            return self;
        };
        self.getContainerWidth = function(domNode) {
            return domNode.offsetWidth;
        };

                self.createPageBackgroundDom = function(bg) { 
        };

            }).apply(self);
    (function() {
        createSendMethod([
            'setSticky', 'stopAdserverAds',
            'disablePosition', 'enablePosition',
            'getPositionParam', 'setPositionParam',
            'moveAdToPosition', 'moveAdToSlot'
        ]);
    }).apply(self);

    (function() {
        function getNextElement(node) {
            do {
                node = node.nextSibling;
            } while (node && node.nodeType !== document.ELEMENT_NODE && node.nextSibling);
            return (node && node.nodeType === document.ELEMENT_NODE) ? node : null;
        }

                function finishDocument() {
            self.AdServer(_adServer).exportMetaData();
            if (!window._isNfi) { doc.close(); }
            self.getConfig('auto-set-iframe-size', function(value) {
                if (value) {
                    doc.documentElement.className = 'testsize';
                    var width = doc.body.firstChild.offsetWidth,
                        height = doc.body.firstChild.offsetHeight;
                    self.Communication.sendMessage(top, 'effectiveAdSize', {width:width, height:height});
                    doc.documentElement.className = '';
                }
                self.trigger('ad.finished', win._adSlot);
            });
        }

                win.checkAdReady = function() {
            var script = doc.getElementById('external-script'),
                check = doc.getElementById('internal-script') || {};
            if (!script) {
                finishDocument();
            } else if (!script.readyState) {
                var checkFunc = function() {
                    if (getNextElement(script) === check && !check.nextSibling) {
                        return win.setTimeout(checkFunc, self.getConfig('friendlyiframe-readycheck-timeout'));
                    }
                    finishDocument();
                };
                checkFunc();
            } else {
                if (!script.checkAdReadyDone && (!script.readyState || script.readyState === 'loaded' || script.readyState === 'complete')) {
                    script.checkAdReadyDone = true;
                    finishDocument();
                }
            }
        };

        self.on('ad.finished', function() {
            win.setTimeout(function() {
                self.Communication.sendMessage(top, 'adFinished', {slot:win._adSlot});
            }, 25);
        });
    }).apply(self);

    self._initialize = function() {
        self.triggerOnce('initialize.begin');
        self.triggerOnce('initialize.end');
    };

};
try {
    new AdService.Module('abd', function() {
            function determine_abd() {
                var el = document.createElement('div');
                el.id             = 'abd-container';
                el.className      = 'gemini-ad advertorial adv ad ad-container ad-contain promoad pub_300x250 plainAd photoad ad-body ad-content adContent ad300x250 adBox adCreative adModule adboxcontent sponsorad ezo_ad';
                el.setAttribute('lazy-ad', 'top_banner');
                el.style.width    = '300px';
                el.style.height   = '250px';
                el.style.position = 'absolute';
                el.style.top      = '-1000px';
                el.style.left     = '-1000px';
                var body = document.getElementsByTagName('body')[0];
                if (body.firstChild) {
                    body.insertBefore(el, body.firstChild);
                } else {
                    body.appendChild(el);
                }
                var height = el.clientHeight || el.offsetHeight,
                    isBlocked = height>0 ? undefined : true,
                _;
                body.removeChild(el);
                if (isBlocked) {
                    AdService.triggerOnce('adblock.detected');
                } else {
                    AdService.triggerOnce('adblock.notdetected');
                }
                return {
                    isBlocked: isBlocked,
                    didCheck: true,
                _:0};
            }
            AdService.registerInfo({
                name: 'abd',
                func: function() { if (AdService.Module('abd').doCheck) { return determine_abd(); } else { return {isBlocked: undefined, didCheck: false}; } },
                persistent: true,
                event: 'body.begin',
                initial: {isBlocked: undefined, didCheck: false}
            });
        })
        .extendBaseObject('setAdserverFallback', function(func) {
            AdService.on('adblock.detected', func);
            return AdService;
        })
        .set('doCheck', true)
        .extendBaseObject('setBlockedCheck', function(yesno) {
            AdService.Module('abd').doCheck = yesno === undefined ? true : yesno;
            return AdService;
        })
    ;
} catch (e) {
    AdService.Module.logError(e);
}
(function(self) {
function getOs(n) {
         if (n.search(/windows\snt\s6\.2;\sarm/) !== -1) { return 18; }
    else if (n.search(/symbian/) !== -1) { return 13; }
    else if (n.search(/xbox/) !== -1) { return 22; }
    else if (n.search(/windows\sphone\s8\.0/) !== -1) { return 23; }
    else if (n.search(/windows\sphone\s8\.1/) !== -1) { return 24; }
    else if (n.search(/windows\sphone\s10\.0/) !== -1) { return 25; }
    else if (n.search(/windows\snt\s10\.0/) !== -1) { return 17; }
    else if (n.search(/windows\snt\s6\.2/) !== -1) { return 15; }
    else if (n.search(/android/) !== -1) { return 12; }
    else if (n.search(/iphone|ipad/) !== -1) { return 14; }
    else if (n.search(/windows\sce/) !== -1) { return 11; }
    else if (n.search(/cros/) !== -1) { return 19; }
    else if (n.search(/playstation/) !== -1) { return 20; }
    else if (n.search(/nintendo/) !== -1) { return 21; }
    else if (n.search(/blackberry/) !== -1) { return 26; }
    else if (n.search(/windows\snt\s6\.3/) !== -1) { return 16; }
    else if (n.search(/nokia/) !== -1) { return 27; }
    else if (n.search(/mac\sos\sx|macintosh|mac\x5fpowerpc/) !== -1) { return 5; }
    else if (n.search(/linux/) !== -1) { return 6; }
    else if (n.search(/unix/) !== -1) { return 7; }
    else if (n.search(/windows\snt\s6\.1/) !== -1) { return 10; }
    else if (n.search(/windows\snt\s6\.0/) !== -1) { return 9; }
    else if (n.search(/windows\snt\s5\.2/) !== -1) { return 8; }
    else if (n.search(/windows\snt\s5\.1/) !== -1) { return 3; }
    else if (n.search(/windows\snt\s5\.0/) !== -1) { return 2; }
    else if (n.search(/windows\snt\s4\.0/) !== -1) { return 4; }
    else if (n.search(/windows\s95|windows\sme|win98|windows\s98/) !== -1) { return 1; }
    return -1;
};
function getBrowser(n) {
         if (n.search(/spotify/) !== -1) { return 31; }
    else if (n.search(/fban|fb_iab/) !== -1) { return 30; }
    else if (n.search(/ucbrowser|ucweb/) !== -1) { return 16; }
    else if (n.search(/silk/) !== -1) { return 28; }
    else if (n.search(/chromium/) !== -1) { return 17; }
    else if (n.search(/yabrowser/) !== -1) { return 20; }
    else if (n.search(/edge/) !== -1) { return 15; }
    else if (n.search(/vivaldi/) !== -1) { return 23; }
    else if (n.search(/qqbrowser/) !== -1) { return 26; }
    else if (n.search(/maxthon|myie/) !== -1) { return 24; }
    else if (n.search(/360se|360ee/) !== -1) { return 25; }
    else if (n.search(/iron/) !== -1) { return 21; }
    else if (n.search(/iceweasel/) !== -1) { return 19; }
    else if (n.search(/metasr/) !== -1) { return 27; }
    else if (n.search(/palemoon/) !== -1) { return 22; }
    else if (n.search(/seamonkey/) !== -1) { return 18; }
    else if (n.search(/trident\/(7\.0)/) !== -1) { return 14; }
    else if (n.search(/nokia/) !== -1) { return 29; }
    else if (n.search(/msie\s10/) !== -1) { return 13; }
    else if (n.search(/msie\s9/) !== -1) { return 12; }
    else if (n.search(/chrome\//) !== -1) { return 11; }
    else if (n.search(/msie\s8/) !== -1) { return 10; }
    else if (n.search(/gecko\//) !== -1) { return 6; }
    else if (n.search(/opera|OPR/) !== -1) { return 7; }
    else if (n.search(/konqueror|safari/) !== -1) { return 8; }
    else if (n.search(/msie\s7/) !== -1) { return 9; }
    else if (n.search(/msie\s6/) !== -1) { return 3; }
    else if (n.search(/msie\s5/) !== -1) { return 2; }
    else if (n.search(/netscape4/) !== -1) { return 4; }
    else if (n.search(/netscape6|netscape\/(7\.\d*)/) !== -1) { return 5; }
    else if (n.search(/msie\s4/) !== -1) { return 1; }
    return -1;
};

function getResolution() {
    var size = screen.width+'x'+screen.height;
    switch (size) {
        case '1024x576':  return 164;
        case '1024x600':  return 165;
        case '1024x768':  return 3;
        case '1072x600':  return 166;
        case '1152x768':  return 167;
        case '1152x864':  return 4;
        case '1152x870':  return 168;
        case '1152x900':  return 169;
        case '1200x800':  return 170;
        case '1200x900':  return 171;
        case '1280x1024': return 5;
        case '1280x720':  return 172;
        case '1280x768':  return 9;
        case '1280x800':  return 10;
        case '1280x854':  return 173;
        case '1280x960':  return 7;
        case '1360x1024': return 179;
        case '1360x768':  return 174;
        case '1366x1024': return 180;
        case '1366x768':  return 175;
        case '1376x768':  return 176;
        case '1400x1050': return 8;
        case '1400x900':  return 177;
        case '1440x900':  return 11;
        case '1440x960':  return 178;
        case '1600x1024': return 183;
        case '1600x1200': return 6;
        case '1600x768':  return 181;
        case '1600x900':  return 182;
        case '1680x1050': return 12;
        case '1920x1080': return 184;
        case '1920x1200': return 13;
        case '1920x1400': return 185;
        case '1920x1440': return 186;
        case '2048x1152': return 187;
        case '2048x1536': return 188;
        case '2560x1440': return 190;
        case '2560x1600': return 191;
        case '2560x2048': return 192;
        case '2800x2100': return 193;
        case  '360x740':  return 464;
        case  '640x480':  return 1;
        case  '720x400':  return 153;
        case  '768x1024': return 199;
        case  '800x480':  return 154;
        case  '800x600':  return 2;
        case  '832x624':  return 159;
        case  '848x480':  return 155;
        case  '852x480':  return 156;
        case  '858x484':  return 158;
        case  '864x480':  return 157;
        case  '960x540':  return 160;
        case  '960x640':  return 162;
        case  '960x720':  return 163;
        case  '964x544':  return 161;
        case 'Sonstige':  return 0;
    }
    return -1;
};

function analyzeMobile() {
    var o = {ua: navigator.userAgent.toLowerCase(), info: {}},
        x = 'browser',
        v = 'version',
        w = window,
        result = {},
        i;
    o.ua.replace(/[\(\)]/g, ';')
        .replace(/\s*(\w*?\ ?\w+[\:\s]?[^\d\s;]*?)[\/\ ;](\d[.\w]*|)/g, function(f, k, v) { o.info[k] = o.info[k] || v || !0; });
    'edge1msie1opr1firefox1seamonkey1aurora1iron1chrome1mobile safari1safari1opera1windows0windows nt0windows phone0windows rt0mac os0os x0android0iphone0ipad0ipod0blackberry0rim0linux0'.replace(/(\D+)(\d)/g, function(n, c, d) { n = +d ? x : 'os'; o.info[c] && (o[n] = o[n] || { name: c == 'opr' ? 'opera' : (c == 'safari' && o.info.android || c == 'chrome' && +o.info[v] == 1) || (o.info.android && c == 'mobile safari') ? 'native' : c == 'os x' ? 'mac os' : c, version: (+d ? o.info[v] : 0) || (o.info[c] === true && o.info.os ? o.info.os.replace(/_/g, '.') : o.info[c]) }, o[n][o[n].name] = parseFloat(o[n][v]) || o[n][v]) });
    (i = +o.info.trident + 4) && (o[x] = {name: 'msie', msie: i, version: i});
    o[x] = o[x] || {name: '', version: ''};
    o.os = o.os || {name: '', version: ''};
    o.retina = 'matchMedia' in w && (w.matchMedia('(-webkit-min-device-pixel-ratio: 2)') || 0).matches;
    o.connection = ['unknown', 'eth', 'wifi', '2g', '3g', '4g'][(navigator.connection || 0).type || 0] || 'unknown';
    o.format = /android(?!.*mobile)|ipad|kindle|playbook|\btab|surface/.test(o.ua) ? 'tab' : /mobi|windows phone|iphone|blackberry/.test(o.ua) ? 'mobile' : 'desktop';
    result.cl   = o.browser.name.slice(0, 3);
    result.clv  = 0 | parseFloat(o.browser.version);
    result.sys  = (o.os.name).slice(0, 3);
    result.sysv = o.os.version || '?';
    result.vpw  = document.documentElement.offsetWidth;
    result.r    = o.retina ? '1' : undefined;
    result.net  = o.connection;
    result.ff   = (({'tab':'m', 'mobile':'s'})[o.format] || 'b');
    result.deviceclass = ({'b':'desktop', 'm':'desktop', 's':'mobile'})[result.ff];
    return result;
};
    var dom = self.gimme('dom'),
        each = self.gimme('each'),
        parseUrl = self.gimme('parseUrl'),
        sizetable = {
            '450x300': 'maxiad',
            '640x360': 'maxiad',
            '640x480': 'maxiad',
            '640x481': 'maxiadcontent',
            '800x450': 'maxiad',
            '800x600': 'maxiad',
            '300x250': 'rectangle',
            '300x115': 'uniteaser',
            '728x90': 'superbanner',
            '120x600': 'skyright',
            '160x600': 'skyright',
            '200x600': 'skyright',
            '320x600': 'skyright',
            '800x250': 'billboard',
            '970x250': 'billboard',
            '994x250': 'billboard',
            '220x600': 'sitebar',
            '300x600': 'halfpage',
            '750x200': 'floor',
            '300x250_630x350': 'content',
            '300x280': 'content_responsive',
            '600x250': 'widecontent',
            '940x300': 'pushdown',
            '960x300': 'pushdown',
            '770x250': 'banderole',
            '848x600': 'tandem_singleton',
            '888x600': 'tandem_singleton',
            '928x600': 'tandem_singleton',
            '1028x600': 'tandem_singleton',
            '1x1': 'ambient',
        _:0},
        uaString = navigator.userAgent.toLowerCase(),
        nextTagId = {},
    _;
    function getDeviceClass() {
        var ua = uaString.replace(/[\(\)]/g, ';');
        var format = /android(?!.*mobile)|ipad|kindle|playbook|\btab|surface/.test(ua) ? 'tab' : /mobi|windows phone|iphone|blackberry/.test(ua) ? 'mobile' : 'desktop',
            ff = (({'tab':'m', 'mobile':'s'})[format] || 'b');
        return ff;
    };
    function getNewPageId() {
        return (Math.random().toString().substr(2, 9));
    };
    function getToolbarInfo() {
        var ua = navigator.userAgent,
            info = {};
        if (/Edge\/|Trident\/|MSIE /.test(ua)) {
            var data = ua.match(/tb-([a-z]+)\/([0-9\.]+)(; \([a-z]+\/[0-9\.]+\))?/i);
            if (data) {
                info.brand = data[1];
                info.version = data[2];
                info.bbrowser = data[3] ? true : false;
            }
        } else {
            var $html = document.getElementsByTagName('html')[0];
            info.kid = $html.getAttribute('united-toolbar-campaignid');
            info.mode = $html.getAttribute('united-toolbar-mode');
            info.variant = $html.getAttribute('united-toolbar-variant');
            info.brand = $html.getAttribute('united-toolbar-brand');
            info.bbrowser = $html.getAttribute('united-toolbar-branded-browser');
            info.version = $html.getAttribute('united-toolbar-version');
        }
        info.hasToolbar = !!info.version;
        return info;
    };
    function getNgUserId() {
        return (document.cookie.match(/(?:^|; )NGUserID=([^;]*)/) || [0, ''])[1];
    };
    function getAutUserId(optout) {
        if (optout) {
            document.cookie = '_autuserid2=; expires=Thu, 01 Jan 1970 00:00:00 GMT';
            return false;
        }
        var value = (document.cookie.match(/(?:^|; )_autuserid2=([^;]*)/) || [0, ''])[1];
        if (!value) {
            var ajax = new XMLHttpRequest();
            ajax.onreadystatechange = function() {
                if (this.readyState !== 4 || this.status !== 200) { return; }
                if (ajax.responseText === '0') { return; }
                aditionUserId = ajax.responseText;
                setAutUserIdCookie(ajax.responseText);
            };
            ajax.withCredentials = true;
            self.on('adblock.detected', function() {
                ajax.open('GET', 'https://united-infos.net/i?raw=1&ts='+(new Date().getTime()), true);
                ajax.send();
            });
            self.on('adblock.notdetected', function() {
                ajax.open('GET', 'https://ad11.adfarm1.adition.com/i?raw=1&ts='+(new Date().getTime()), true);
                ajax.send();
            });
        } else {
            setAutUserIdCookie(value);
        }
        return value;
    };
    function setAutUserIdCookie(value) {
        var domain = location.host.split('.').splice(-2).join('.');
        var expires = new Date();
        expires.setTime(expires.getTime() + 2*365*24*60*60*1000);
        document.cookie = '_autuserid2=' + value
                        + '; domain=.' + domain
                        + '; path=/'
                        + '; SameSite=None'
                        + '; Secure'
                        + '; expires=' + expires.toGMTString()
        ;
    };
    var nguserid = getNgUserId();
    var aditionUserId;
    self.on('server.setparam', function(evt) {
        if (evt.data.params.hasOwnProperty('userid') && typeof evt.data.params.userid !== 'function') {
            aditionUserId = evt.data.params.userid;
        }
    });
    function getIframe() {
        var iframe = 0;
        try {
            if (top.location !== window.location) { iframe = 1; }
            if (window.frameElement)              { iframe = 1; }
        } catch (e) {
            iframe = 1;
        }
        return ''+iframe;
    };

    function setSecuredParam(name, value) {
        self.getDefaultAdServer()[securedSymbol].setSecuredParam(name, value);
    }

    var mobileParams = analyzeMobile(),
        createAdServer = function(id, config, params) {
            var tagidListForPrf = {};
            var posCount = {};
            var ac = 1;
            var server = new AdService.AdServer(id, AdService.Helper.extend({
                probableDefault: true,
                host: 'ad11.adfarm1.adition.com',
                path: 'lt',
                paramOrder: {
                    begin: [
                        'wpt', 'nw', 'lt', 'ac', 'portal', 'category', 'section', 'tagid', 'layoutclass',
                        'posIndex', 'posCount', 'wi', 'ref',
                        'os', 'browser', 'screen_res', 'iframe', 'fvers',
                        'external_uid', 'uid_stable', 'optout', 'userid', 'gdpr', 'gdpr_consent',
                        'prf[portal]', 'prf[category]', 'prf[section]', 'prf[tagid]', 'prf[layoutclass]',
                        'prf[deviceclass]', 'prf[deviceclient]',
                        'prf[sectionlong]', 'prf[categorytype]',
                        'prf[os]', 'prf[browser]', 'prf[screen_res]', 'prf[iframe]', 'prf[fvers]',
                        'prf[sys]', 'prf[sysv]', 'prf[cl]', 'prf[clv]', 'prf[vpw]', 'prf[net]',
                        'prf[external_uid]', 'prf[hid]', 'prf[nguserid]', 'prf[uids]', 'prf[optout]',
                        'prf[pp]', 'prf[pa]', 'prf[pg]'
                    ],
                    end:    ['prf[pageview]', 'debug'],
                    ignore: ['posName', 'ff']
                },
                evenIfEmpty: ['ref', 'iframe', 'fvers', 'external_uid', 'uid_stable', 'prf[nguserid]', 'prf[uids]', 'prf[hid]'],
                paramTypes: {
                    direct: ['lt', 'ac', 'nw', 'uid_stable', 'userid', 'wpt', 'sid', 'bid', 'kid', 'ref', 'gdpr', 'gdpr_consent', 'debug'],
                    both:   ['wi', 'os', 'browser', 'iframe', 'screen_res', 'fvers', 'optout', 'external_uid', 'hid'],
                    ignore: ['ff']
                },
                nonContentElements: ['uim:ad'],
                init: function() {
                    var info = getToolbarInfo();
                    this.setParam({
                        toolbar: info.hasToolbar ? '1' : '0',
                        brandedbrowser: !!info.bbrowser ? '1' : '0'
                    });
                    this.setParam({
                        uid_stable: '0',
                        uids: '0',
                        external_uid: nguserid,
                        nguserid: nguserid,
                        optout: nguserid==='TGP-OPT-OUT' ? '1' : '0',
                        consentlevel: this.getParam('consentLevel') || (document.cookie.match(/(?:^|; )consentLevel=([^;]*)/) || [0, ''])[1] || undefined,
                        google_ac: '0',
                    });
                    var dnt = window.doNotTrack == '1' || navigator.doNotTrack == 'yes' || navigator.doNotTrack == '1' || navigator.msDoNotTrack == '1';
                    this.setParam({
                        dnt: dnt ? '1' : '0'
                    });
                    this.setParam({
                        os: getOs(uaString),
                        browser: getBrowser(uaString)
                    });
                }
            }, config), AdService.Helper.extend({
                ac: function() {
                    return ac;
                },
                nw: 42,
                deviceclient: 'browser',
                wpt: function(slot) {
                    if (slot instanceof AdService.AdSlot) {
                        switch (slot.type) {
                            case 'iframe':
                                return 'h';
                                break;
                            case 'javascript':
                            default:
                                return 'j';
                                break;
                        }
                    }
                },
                deviceclass:  getDeviceClass(),
                external_uid: '',
                uid_stable:   0,
                wi:           getNewPageId(),
                fvers:        self.info.flash().major,
                ref:          location.href || '',
                iframe:       getIframe(),
                screen_res:   getResolution(),
                cl:           mobileParams.cl,
                clv:          mobileParams.clv,
                sys:          mobileParams.sys,
                sysv:         mobileParams.sysv,
                vpw:          mobileParams.vpw,
                r:            mobileParams.r,
                net:          mobileParams.net,
                ff:           mobileParams.ff,
                tagid: function(slot) {
                    if (slot instanceof AdService.AdSlot) {
                        return slot.id;
                    }
                },
                userid: function(slot) {
                    return aditionUserId;
                }
            }, params)
        );

        server.isAditionServer = true;

        server._specialParams = {
            _order: ['tagid_x', 'lt', 'maxwidth', 'bannerid', 'btid'],
            tagid_x: function(params, slot) {
                var rawTagid = (''+(nextTagId[slot.id]||params.tagid)).replace(/_x/g, '');
                if (params.tagid in tagidListForPrf && (params.tagid.indexOf('_x') === -1)) {
                    params.tagid += '_x';
                }
                if (nextTagId[slot.id]) {
                    params.tagid = nextTagId[slot.id];
                    delete nextTagId[slot.id];
                }
                posCount[rawTagid] = (posCount[rawTagid] || 0) + 1;
                params.pos = posCount[rawTagid];
                tagidListForPrf[params.tagid] = true;
            },
            lt: function(params, slot) {
                this.config.sepNameValue = '(';
                this.config.sepParams = ')';
                var lt = this._getParamString({
                    portal: params.portal,
                    category: params.category,
                    section: params.section,
                    tagid: params.tagid,
                    layoutclass: params.layoutclass
                }, slot);
                this.config.sepNameValue = '=';
                this.config.sepParams = '&';
                params.lt = lt + ')';
            },
            maxwidth: function(params, slot) {
                if (!params.hasOwnProperty('maxwidth')) {
                    params.maxwidth = slot.getContainerWidth();
                }
            },
            bannerid: function(params, slot) {
                if (params.bannerid) {
                    var ids = params.bannerid.split(';');
                    each(ids, function(i, id) {
                        var parts = id.split(',');
                        if (parts[1] === slot.id) {
                            params.bid = parts[0];
                            params.ac = -1;
                        }
                    });
                    delete params.bannerid;
                }
            },
            btid: function(params, slot) {
                if (params.btid) {
                    var ids = params.btid.split(';');
                    each(ids, function(i, id) {
                        var parts = id.split(',');
                        if (parts[1] === params.tagid) {
                            params.bid = parts[0];
                            params.ac = -1;
                        }
                    });
                    delete params.btid;
                }
            },
        };

        server.prepareParamsForUrl = function(params, slot) {
            var server = this;
            slot = self._getAdSlot(slot);
            each(server._specialParams._order, function(i, name) {
                server._specialParams[name].call(server, params, slot);
            });
            each(params, function(key, value) {
                if (server.config.paramTypes.direct.indexOf(key) === -1 && server.config.paramTypes.ignore.indexOf(key) === -1) {
                    if (key.indexOf('prf[') === 0) {
                        params[key] = value;
                    } else if (!params.hasOwnProperty('prf['+key+']')) {
                        params['prf['+key+']'] = value;
                    }
                }
            });
            each(params, function(key, value) {
                if (key.indexOf('prf[') === -1 && server.config.paramTypes.direct.indexOf(key) === -1 && server.config.paramTypes.both.indexOf(key) === -1) {
                    delete params[key];
                }
                if (server.config.paramTypes.ignore.indexOf(key) >= 0) {
                    delete params[key];
                }
            });
            return params;
        };

        server.getUrl = function(slot, requestMethod) {
            slot = self._getAdSlot(slot);
            var url = this.config.protocol + this.config.host + '/' + this.config.path + this.config.sepQuery,
                params = this.getUrlParams(slot),
            _;
            if (requestMethod===AdService.Const.REQUEST_METHOD.FRIENDLY_IFRAME || requestMethod===AdService.Const.REQUEST_METHOD.NONFRIENDLY_IFRAME) {
                params.iframe = params['prf[iframe]'] = '1';
            }
            url += this._getParamString(AdService.Helper.extend(
                {wpt: requestMethod===AdService.Const.REQUEST_METHOD.NONFRIENDLY_IFRAME ? 'h' : 'j'},
                params
            ), slot);
            return url;
        };

        server.renderMeta = function(html, meta) {
            var metaHtml = '<uim:ad xmlns:uim="urn:publicid:-:UIM:adinfo" ';
            each(meta, function(name, value) {
                metaHtml += name+'="'+value+'" ';
            });
            metaHtml += '></uim:ad>\n';
            return metaHtml + html;
        };
        server.exportMetaData = function() {
            var html = (document.getElementsByTagName('uim:ad')[0] || {outerHTML:''}).outerHTML;
            self.sendMessage(top, 'importMetaData', html);
            return this;
        };
        server.importMetaData = function(data) {
            var uimAdTags = data.iframe.parentNode.getElementsByTagName('uim:ad');
            if (uimAdTags) {
                for (var i=uimAdTags.length-1; i>=0; i--) {
                    data.iframe.parentNode.removeChild(uimAdTags[i]);
                }
            }
            data.iframe.insertAdjacentHTML('beforebegin', data.message.data);
        };

        server.newPageContext = function() {
            this.setParam('wi', getNewPageId());
            return this;
        };
        server.getAdSize = function(domNode) {
            try {
                var adSize = domNode.getElementsByTagName('uim\:ad')[0].getAttribute('adsize');
                var dimensions = adSize.split('x');
                return {
                    width: dimensions[0],
                    height: dimensions[1]
                }
            } catch (e) { }
            return {};
        };
        server.getAdFormByMetaData = function(meta, fallbackAllowed) {
            return meta ? (sizetable[meta.adsize] || (fallbackAllowed ? meta.adsize : undefined)) : undefined;
        };
        server.getEventsByMetaData = function(meta) {
            return {
                form: server.getAdFormByMetaData(meta),
                size: meta.adsize,
            _:0};
        };

        server.splitMultiResponse = function(domNode) {
            var parts = [];
            each(domNode.childNodes, function(i, node) {
                if (node.nodeName.toLowerCase() === 'div') {
                    parts.push(node);
                }
            });
            return parts;
        };

        server.increaseRequestCount = function(newAc) {
            if (typeof newAc === typeof 42) {
                ac = newAc;
            } else {
                ac++;
            }
        };

        server.checkUrlValidity = function(url) {
            url = parseUrl(url);
            return (server.config.validHosts || [server.config.host]).indexOf(url.hostname) >= 0;
        };

        self.on('ad.urlReady', function(evt) {
            if (evt.slot && evt.slot.getAdServer().isAditionServer && evt.slot.getAdServer().id === server.id) {
                server.increaseRequestCount();
            }
        });

        return server;
    };

    self.on('server.setparam', function(evt) {
        if (evt.data.params.hid) {
            evt.data.params.external_uid = evt.data.params.hid;
            evt.data.params.uid_stable = 1;
            evt.data.params.uids = 1;
        }
    });

    self.on('server.setconfig', function(evt) {
        if (evt.data.config.type === 'iframe') {
            evt.slot.setParam('wpt', 'j');
            evt.data.config.requestType = Const.REQUEST_TYPE.ASYNC;
            evt.data.config.secure = true;
        }
    });

    self.on('ad.property.nextTagId', function(evt) {
        nextTagId[evt.slot.id] = evt.data.nextTagId;
    });

    self.on('auction.complete', function(evt) {
        each(evt.data, function(slot, item) {
            self.setSlotParam(slot, 'pb_adid', item.adId);
            self.setSlotParam(slot, 'pb_size', item.size);
            self.setSlotParam(slot, 'pb_partner', item.bidderCode);
            self.setSlotParam(slot, 'pb_deal', item.dealId || 0);
            self.setSlotParam(slot, 'pb_price', parseInt(100*item.cpm));
            self.setSlotParam(slot, 'pb_type', item.mediaType);
            if (item.mediaType === 'video') {
                self.setSlotParam(slot, 'pb_videocachekey', item.videoCacheKey);
            }
            self.log.level(
                'auction',
                'Params set for slot', slot,
                '--',
                'pb_size:', item.size,
                'pb_partner:', item.bidderCode,
                'pb_deal:', item.dealId || 0,
                'pb_price:', parseInt(100*item.cpm),
                'pb_type:', item.mediaType,
                'item:', item
            );
        });
    });

    self.getDeviceClass = self.getDeviceClass || function() {
        return self.getParam('deviceclass');
    };

    var here = location.host.split('.').slice(-2).join('.'),
        host = 'united-infos.net';
    switch (here) {
        case '1und1.de':
        case 'gmx.at':
        case 'gmx.ch':
        case 'gmx.net':
        case 'web.de':
            host = 'info.'+here;
            break;
    }
    var AditionAspAdServer = createAdServer('adition-asp');
    var AditionAspInfoServer = createAdServer('adition-asp-info', {
        host: host,
        validHosts: ['united-infos.net', 'info.1und1.de', 'info.gmx.at', 'info.gmx.ch', 'info.gmx.net', 'info.web.de'],
        firstUse: function() {
            this.config = AdService.Helper.extend({}, AditionAspAdServer.config, this.config);
            this.params = AdService.Helper.extend({}, AditionAspAdServer.params, this.params);
        }
    }, {
        tagid: function(slot) {
            return (slot instanceof AdService.AdSlot && slot.getConfig('fallbackTagid')) || (slot.id + '_info');
        }
    });
    var AditionAspInfoServer = createAdServer('adition-asp-united-infos', {
        host: 'united-infos.net',
        firstUse: function() {
            this.config = AdService.Helper.extend({}, AditionAspAdServer.config, this.config);
            this.params = AdService.Helper.extend({}, AditionAspAdServer.params, this.params);
        }
    }, {
        tagid: function(slot) {
            return (slot instanceof AdService.AdSlot && slot.getConfig('fallbackTagid')) || (slot.id + '_united');
        }
    });
    var AditionAspInfoServer = createAdServer('adition-asp-united-uimserv', {
        host: 'united.uimserv.net',
        firstUse: function() {
            this.config = AdService.Helper.extend({}, AditionAspAdServer.config, this.config);
            this.params = AdService.Helper.extend({}, AditionAspAdServer.params, this.params);
        }
    }, {
        tagid: function(slot) {
            return (slot instanceof AdService.AdSlot && slot.getConfig('fallbackTagid')) || (slot.id + '');
        }
    });
    var AditionAspInfoServer = createAdServer('adition-asp-consent-uimserv', {
        host: 'united.uimserv.net',
        firstUse: function() {
            this.config = AdService.Helper.extend({}, AditionAspAdServer.config, this.config);
            this.params = AdService.Helper.extend({}, AditionAspAdServer.params, this.params);
        }
    });

    if (self._isConnector) {
        self.adMeta = function(meta) {
            self._adMeta = meta;
            self.sendMessage(top, 'adMeta', arguments, function(evt) {
                self.trigger('answer.adMeta', evt);
            });
            return self;
        };
    } else {
        self.adMeta = function(meta) { 
            self._getCurrentAdSlot().addMetaData(meta);
            return self;
        };
    }

    if (self._isConnector) {
        self.on('ad.finished', function(evt) {
            if (!self._adMeta) {
                var uimAd = document.getElementsByTagName('uim\:ad')[0],
                    attr = uimAd ? uimAd.getAttribute : function() { return undefined; },
                    meta = {
                        contentunitid: attr.call(uimAd, 'contentunitid'),
                        campaignid: attr.call(uimAd, 'campaignid'),
                        bannerid: attr.call(uimAd, 'bannerid'),
                        portal: attr.call(uimAd, 'portal'),
                        category: attr.call(uimAd, 'category'),
                        section: attr.call(uimAd, 'section'),
                        tagid: attr.call(uimAd, 'tagid'),
                        layoutclass: attr.call(uimAd, 'layoutclass'),
                        width: attr.call(uimAd, 'width'),
                        height: attr.call(uimAd, 'height'),
                        adsize: attr.call(uimAd, 'adsize'),
                        ovkid: attr.call(uimAd, 'ovkid')
                    },
                _;
                self.adMeta(meta);
            }
        });
    }

self.on('initialize.end', function() {
    var defaultOptIn = true;
    var uiConsent = defaultOptIn ? {
        publisher: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        purpose: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        specialFeature: [1, 2],
    } : {};

    try {
        window.__tcfapi('getTCData', 2, function(response) {
            function createConsentArray(data) {
                if (!data) { return []; }
                if (data.consents) { data = data.consents; }
                return Object.keys(data).filter(function(i) { return data[i]; }).map(function(i) { return parseInt(i); });
            }
            if (response.tcString !== '') {
                uiConsent.tcString = response.tcString;
                uiConsent.publisher = createConsentArray(response.publisher);
                uiConsent.purpose = createConsentArray(response.purpose);
                uiConsent.specialFeature = createConsentArray(response.specialFeatureOptins);
                window.__tcfapi('getPermission', 2, function(response) {
                    uiConsent.google = response;
                    if (response) {
                        window.__tcfapi('getACString', 2, function(acString) {
                            uiConsent.acString = acString;
                        });
                    } else {
                        delete uiConsent.acString;
                    }
                }, 'googleAc');
                window.__tcfapi('getPermission', 2, function(response) {
                    if (response) { uiConsent.permissionFeature = ['fullConsent']; }
                }, 'fullConsent');
                window.__tcfapi('getTCFVersion', 2, function(response) {
                	uiConsent.version = parseFloat(response);
                    setSecuredParam('tcf_version', uiConsent.version);
                }, null);
            }
        });
    } catch (e) {
        uiConsent.tcString = (document.cookie.match(/(?:^|; )euconsent-v2=([^;]*)/) || [0, ''])[1];
        try {
            uiConsent = JSON.parse((document.cookie.match(/(?:^|; )uiconsent=([^;]*)/) || [0, ''])[1]);
            uiConsent.google = false;
        } catch (e) {
        }
    }

    if (!(uiConsent.publisher instanceof Array)) { uiConsent.publisher = []; }
    if (!(uiConsent.purpose instanceof Array)) { uiConsent.purpose = []; }
    if (!(uiConsent.specialFeature instanceof Array)) { uiConsent.specialFeature = []; }
    uiConsent.optout = self.getParam('optout');


    function hasConsent(obj, list) {
        if (uiConsent.fullConsent) { return true; }
        return list.reduce(function(result, i) {
            return result && obj.indexOf(i) !== -1;
        }, true);
    }
    function hasPublishers() {
        return hasConsent(uiConsent.publisher, Array.prototype.slice.call(arguments));
    }
    function hasPurposes() {
        return hasConsent(uiConsent.purpose, Array.prototype.slice.call(arguments));
    }
    function hasSpecialFeatures() {
        return hasConsent(uiConsent.specialFeature, Array.prototype.slice.call(arguments));
    }

    if (uiConsent.tcString) {
        setSecuredParam('prf[optout]', uiConsent.optout);
        setSecuredParam('optout', undefined);
        setSecuredParam('consentlevel', undefined);
        setSecuredParam('gdpr', 1);
        setSecuredParam('gdpr_consent', uiConsent.tcString);
        setSecuredParam('google_ac', (uiConsent.acString && uiConsent.acString !== '1~') ? '1' : '0');

        if (!hasPublishers(1, 2) && self.getParam('deviceclient')==='browser' && !(!!self.info.abd().isBlocked)) {
            self.setDefaultAdServer('adition-asp-consent-uimserv');
        }

        if (hasPublishers(1)) {
            aditionUserId = getAutUserId(nguserid==='TGP-OPT-OUT') || undefined;
        } else {
        	setSecuredParam('userid', undefined);
        }

        if (!hasPublishers(2)) {
            [
                'deviceclass', 'cl', 'clv', 'sys', 'sysv', 'os', 'browser', 'screen_res',
                'vpw', 'toolbar', 'brandedbrowser', 'weather_temp', 'weather_condition', 'clktype',
                'view', 'camera', 'hw', 'hwversion', 'appvers', 'd', 'retina', 'orient',
                'net', 'apilevel', 'interstitial', 'screensizewidth', 'screensizeheight', 'maxsize', 'fvers'
            ].forEach(function(item) {
                setSecuredParam(item, undefined);
            });
        }

        if (!hasPublishers(1, 3)) {
            ['prf[hid]', 'prf[nguserid]', 'prf[external_uid]', 'prf[idfa]'].forEach(function(item) {
                setSecuredParam(item, undefined);
            });
        }

        if (!hasPublishers(1, 3, 4)) {
            self.setParam('prf[external_uid]', self.getParam('external_uid'));
            setSecuredParam('external_uid', undefined);
        }

        if (!hasPublishers(3, 4)) {
            ['pa', 'pp', 'pg', 'userlevel'].forEach(function(item) {
                setSecuredParam(item, undefined);
            });
        }

        setSecuredParam('tcf_pub', ','+uiConsent.publisher.join()+',');
        setSecuredParam('tcf_pur', ','+uiConsent.purpose.join()+',');
        setSecuredParam('tcf_spe', ','+uiConsent.specialFeature.join()+',');
    } else {
        setSecuredParam('tcf_version', '1.1');
        if (uiConsent.optout == 1) {
            setSecuredParam('optout', '1');
            setSecuredParam('tcf_pub', ',,');
            setSecuredParam('tcf_pur', ',,');
            setSecuredParam('tcf_spe', ',,');
            ['prf[hid]', 'prf[nguserid]', 'external_uid', 'prf[idfa]', 'prf[pp]', 'prf[pa]', 'prf[pg]', 'userid'].forEach(function(item) {
                setSecuredParam(item, '');
            });
        } else {
            setSecuredParam('optout', '0');
            var consentLevel = self.getParam('consentlevel');
            if (consentLevel == 2 || consentLevel == 3) {
                setSecuredParam('tcf_pub', ',1,2,3,4,5,6,7,8,9,10,');
                setSecuredParam('tcf_pur', ',1,2,3,4,5,6,7,8,9,10,');
                setSecuredParam('tcf_spe', ',1,2,');
            } else {
                setSecuredParam('tcf_pub', ',,');
                setSecuredParam('tcf_pur', ',,');
                setSecuredParam('tcf_spe', ',,');
            }
        }
    }
});
}).apply(self, [AdService]);

    AdService._initialize();

})();
